import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const SUPPORTED_LANGS = ['ru', 'en', 'ro'];
const normalizeLanguage = (lang) => {
  if (!lang) return null;
  const normalized = String(lang).toLowerCase().split('-')[0];
  return SUPPORTED_LANGS.includes(normalized) ? normalized : null;
};
const initialLanguage = normalizeLanguage(localStorage.getItem('lng')) || 'ru';

i18n.use(initReactI18next).init({
  resources: {
    ru: {
      translation: {
        homepage: {
          badge: 'Рабочее место поддержки TeSalut',
          greeting: {
            morning: 'Доброе утро',
            day: 'Добрый день',
            evening: 'Добрый вечер',
            night: 'Доброй ночи'
          },
          titleLead: 'Поддержка TeSalut\u00A0—',
          titleAccent: 'быстро и в одном окне',
          lead: 'Заказы, пользователи, жалобы и логи всегда под рукой. Разбирайте обращения, ведите карточки клиентов и мастеров и держите связь с командой, не переключаясь между сервисами.',
          ctaPrimary: 'Перейти к заказам',
          ctaSecondary: 'Найти пользователя',
          role: 'Ваша роль',
          stats: {
            users: 'Пользователей',
            usersHint: 'Всего в системе',
            newUsers: 'Новых сегодня',
            newUsersHint: 'Зарегистрировались с полуночи',
            orders: 'Заказов',
            ordersHint: 'За всё время',
            complaints: 'Открытых жалоб',
            complaintsHint: 'Ждут рассмотрения',
            unavailable: 'Нет данных'
          },
          sections: {
            badge: 'Разделы',
            title: 'С чего начнём сегодня?',
            subtitle: 'Здесь только те разделы, которые доступны вашей роли.',
            open: 'Открыть',
            orders: 'Поиск заказов, статусы, участники и история изменений.',
            users: 'Карточки клиентов и мастеров: баланс, отзывы, комментарии поддержки.',
            complaints: 'Разбор жалоб на пользователей, заказы и комментарии.',
            chat: 'Переписка с командой: личные чаты, группы, файлы и голосовые.',
            calendar: 'Расписание команды: дежурства, релизы и встречи.',
            logs: 'Системные логи и журнал модерации заказов.',
            statistics: 'Графики по пользователям, заказам и отзывам за любой период.',
            admin: 'Промокоды, рассылки, маркетплейс, баннеры и сотрудники.'
          },
          tips: {
            badge: 'Подсказки',
            title: 'Работайте быстрее',
            subtitle: 'Несколько приёмов, которые экономят время в ежедневной работе.',
            searchTitle: 'Поиск по ID',
            searchText: 'Вставьте полный UUID в фильтр, и карточка откроется сразу, без перебора страниц.',
            exportTitle: 'Выгрузка для рассылки',
            exportText: 'Меню «Действия» в разделе пользователей выгрузит только тех, кто согласился на рассылку.',
            themeTitle: 'Светлая и тёмная тема',
            themeText: 'Переключатель в верхней панели, выбор запоминается.',
            languageTitle: 'Три языка',
            languageText: 'Русский, English и Română, язык меняется в верхней панели.'
          }
        },
        devNotice: {
          title: 'Страница в разработке',
          text: 'Раздел ещё дорабатывается: данные показываются из тестового набора и могут отображаться некорректно. Ничего из того, что вы здесь измените, пока не сохраняется на сервере.',
          button: 'Понятно'
        },
        chat: {
          title: 'Чат',
          subtitle: 'Общение с пользователями и командой',
          connection: {
            connecting: 'Подключаемся к чату...',
            reconnecting: 'Переподключаемся к чату...',
            failed: 'Realtime-соединение недоступно — сообщения уходят и приходят через обычные запросы',
            retry: 'Повторить'
          },
          errors: {
            history: 'Не удалось загрузить историю сообщений',
            generic: 'Ошибка чата'
          },
          list: {
            title: 'Сообщения',
            searchPlaceholder: 'Поиск по чатам',
            empty: 'Чатов пока нет',
            notFound: 'Ничего не найдено',
            newChat: 'Написать новому человеку',
            newGroup: 'Новая группа',
            writeToEmployee: 'Написать сотруднику',
            createGroup: 'Создать группу',
            unpin: 'Открепить',
            unmute: 'Включить уведомления'
          },
          window: {
            empty: 'Выберите чат, чтобы начать переписку',
            activeNow: 'В сети',
            typing: 'печатает…',
            typingNamed: '{{name}} печатает…',
            members: '{{count}} участников',
            offline: 'офлайн',
            offlineHint: 'Нет соединения — сообщения уходят через обычные запросы',
            actions: 'Действия',
            pin: 'Закрепить',
            unpin: 'Открепить',
            mute: 'Отключить уведомления',
            unmute: 'Включить уведомления',
            rename: 'Переименовать группу',
            save: 'Сохранить',
            participants: 'Участники группы'
          },
          composer: {
            placeholder: 'Написать сообщение...',
            placeholderNamed: 'Сообщение для {{name}}...',
            attach: 'Прикрепить файл',
            emoji: 'Эмодзи',
            voice: 'Записать голосовое',
            send: 'Отправить',
            cancelReply: 'Отменить ответ',
            uploadError: 'Не удалось загрузить файл',
            voiceError: 'Не удалось отправить голосовое',
            recordCancel: 'Отменить',
            recordSend: 'Отправить голосовое'
          },
          message: {
            reply: 'Ответить',
            react: 'Реакция',
            image: 'Изображение'
          },
          preview: {
            photo: 'Фото',
            voice: 'Голосовое сообщение',
            file: 'Файл'
          },
          system: {
            memberAdded: '{{author}} добавил {{member}}',
            memberRemoved: '{{author}} удалил {{member}}',
            memberLeft: '{{member}} покинул группу',
            titleChanged: '{{author}} переименовал группу в «{{title}}»',
            unknown: 'Участник'
          },
          date: {
            today: 'Сегодня',
            yesterday: 'Вчера'
          },
          fallback: {
            group: 'Группа',
            order: 'Заказ {{id}}',
            user: 'Пользователь {{id}}',
            chat: 'Чат'
          },
          participants: {
            title: 'Участники',
            count: '{{count}} человек',
            add: 'Добавить участников',
            remove: 'Удалить из группы',
            you: 'вы',
            leave: 'Покинуть группу',
            leaveConfirm: 'Выйти из группы?',
            leaveCancel: 'Отмена',
            leaveAction: 'Выйти',
            leaving: 'Выходим...',
            removeError: 'Не удалось удалить участника',
            leaveError: 'Не удалось выйти из группы',
            roles: {
              OWNER: 'Владелец',
              ADMIN: 'Админ'
            }
          },
          picker: {
            directTitle: 'Новый чат',
            directSub: 'Поиск сотрудника по имени',
            groupTitle: 'Новая группа',
            groupSub: 'Название и участники',
            addTitle: 'Добавить участников',
            addSub: 'Те, кто уже в группе, скрыты',
            namePlaceholder: 'Название группы',
            searchPlaceholder: 'Введите имя...',
            allRoles: 'Все роли',
            notFound: 'Никого не нашли',
            selected: 'Выбрано {{count}}',
            selectedMin: 'Выбрано {{count}}, нужно минимум {{min}}',
            create: 'Создать группу',
            add: 'Добавить',
            saving: 'Сохраняем...',
            loadError: 'Не удалось загрузить список сотрудников',
            actionError: 'Не удалось выполнить действие',
            openChatError: 'Не удалось открыть чат с этим пользователем',
            roles: {
              SUPPORT: 'Саппорт',
              MODERATOR: 'Модератор',
              ADMIN: 'Админ',
              DEV: 'Разработчик'
            }
          }
        },
        calendar: {
          title: 'Календарь',
          subtitle: 'Расписание команды и события админки',
          newEvent: 'Новое событие',
          newCalendar: 'Новый календарь',
          today: 'Сегодня',
          prev: 'Назад',
          next: 'Вперёд',
          searchPlaceholder: 'Поиск событий...',
          views: {
            month: 'Месяц',
            list: 'Список'
          },
          more: 'ещё {{count}}',
          agendaEmpty: 'Событий нет',
          dialog: {
            createTitle: 'Новое событие',
            createSub: 'Добавьте событие в календарь',
            editTitle: 'Событие',
            editSub: 'Изменение события календаря',
            name: 'Название',
            namePlaceholder: 'Введите название события...',
            calendar: 'Календарь',
            date: 'Дата',
            time: 'Время',
            duration: 'Длительность',
            options: 'Опции',
            allDay: 'Весь день',
            reminder: 'Напоминание',
            location: 'Место',
            locationPlaceholder: 'Переговорка, ссылка на звонок...',
            attendees: 'Участники',
            attendeePlaceholder: 'Добавить участника...',
            add: 'Добавить',
            description: 'Описание',
            descriptionPlaceholder: 'Добавьте описание...',
            create: 'Создать событие',
            save: 'Сохранить',
            cancel: 'Отмена',
            delete: 'Удалить',
            close: 'Закрыть',
            durations: {
              '15': '15 мин',
              '30': '30 мин',
              '45': '45 мин',
              '60': '1 час',
              '90': '1,5 часа',
              '120': '2 часа',
              '180': '3 часа',
              '1440': 'Весь день'
            }
          }
        },
        statistics: {
          title: 'Статистика',
          subtitle: 'Показатели сервиса и ключевые метрики в реальном времени',
          newReport: 'Новый отчёт',
          actions: 'Действия',
          export: 'Экспорт',
          sales: {
            title: 'Динамика продаж',
            subtitle: 'Продажи по месяцам против плана',
            sales: 'Продажи',
            target: 'План'
          },
          revenue: {
            title: 'Структура выручки',
            subtitle: 'Распределение по источникам'
          },
          transactions: {
            title: 'Последние транзакции',
            subtitle: 'Свежие операции клиентов',
            viewAll: 'Все операции'
          },
          products: {
            title: 'Топ услуг',
            subtitle: 'Лучшие позиции за месяц',
            viewAll: 'Смотреть все',
            sales: '{{count}} продаж',
            stock: 'Остаток: {{count}}'
          },
          insights: {
            title: 'Аналитика по клиентам',
            subtitle: 'Динамика роста и демография',
            tabs: {
              growth: 'Рост',
              demographics: 'Демография',
              regions: 'Регионы'
            },
            growthTitle: 'Динамика клиентской базы',
            ageTitle: 'Возрастные группы',
            regionsTitle: 'Распределение по регионам',
            keyMetrics: 'Ключевые показатели',
            series: {
              new: 'Новые',
              returning: 'Вернулись',
              churned: 'Ушли'
            }
          }
        },
        common: {
          language: 'Язык',
          loading: 'Загрузка...',
          saved: 'Сохранено!',
          notFound: 'Страница не найдена',
          error: 'Ошибка',
          back: 'Назад',
          backToList: 'Назад к списку',
          view: 'Подробнее',
          search: 'Найти',
          searchLoading: 'Поиск...',
          clear: 'Очистить',
          reset: 'Сбросить',
          save: 'Сохранить',
          cancel: 'Отмена',
          close: 'Закрыть',
          yes: 'Да',
          no: 'Нет',
          page: 'Страница {{page}}',
          total: '{{count}} всего',
          status: 'Статус',
          ms: 'мс',
          copy: 'Копировать',
          copied: 'Скопировано!',
          notProvided: 'Не указано',
          actions: 'Действия',
          description: 'Описание',
          createdAt: 'Дата создания',
          updatedAt: 'Дата обновления',
          pagination: {
            showing: 'Показано {{from}} - {{to}} из {{total}}',
            previous: 'Назад',
            next: 'Вперед',
            page: 'Страница {{page}}',
            pageOf: 'Страница {{page}} из {{total}}',
            itemsPerPage: 'Элементов на странице',
            noResults: 'Нет результатов',
            items: 'элементов'
          },
          houseShort: 'д.',
          apartmentShort: 'кв.',
          datePicker: {
            placeholderDateTime: 'ДД.ММ.ГГГГ ЧЧ:ММ',
            placeholderDate: 'ДД.ММ.ГГГГ',
            increase: 'Увеличить',
            decrease: 'Уменьшить',
            clear: 'Очистить',
            hourLetter: 'ч',
            minuteLetter: 'м',
            ok: 'ОК',
            now: 'Сейчас',
            time: 'Время',
            date: 'Дата'
          },
          next: 'Далее'
        },
        imageViewer: {
          title: 'Просмотр изображения',
          prev: 'Предыдущее',
          next: 'Следующее',
          zoomIn: 'Увеличить',
          zoomOut: 'Уменьшить',
          loadError: 'Не удалось загрузить изображение',
          avatar: 'Аватар пользователя',
          openAvatar: 'Открыть аватар',
          showMore: 'Ещё {{n}}',
          showLess: 'Свернуть'
        },
        nav: {
          sections: {
            workspace: 'Разделы',
            tools: 'Инструменты',
            admin: 'Администрирование'
          },
          searchTitle: 'Что вам нужно?',
          searchPlaceholder: 'Поиск по разделам...',
          openMenu: 'Открыть меню',
          collapse: 'Свернуть меню',
          expand: 'Развернуть меню',
          logo: 'SalutApp Admin',
          home: 'Главная',
          logs: 'Логи',
          orders: 'Заказы',
          users: 'Пользователи',
          complaints: 'Жалобы',
          chat: 'Чат',
          statistics: 'Статистика',
          calendar: 'Календарь',
          tools: 'Инструменты',
          chatHint: 'Переписка с командой',
          statisticsHint: 'Показатели сервиса',
          calendarHint: 'Расписание и события',
          admin: 'Админка',
          logout: 'Выйти',
          userFallback: 'Пользователь',
          languageSwitcher: 'Язык',
          theme: {
            switchToDark: 'Тёмная тема',
            switchToLight: 'Светлая тема'
          }
        },
        footer: {
          copyright: '© {{year}} COOLCHAS COMMUNITY SRL – TeSalut. Все права защищены'
        },
        admin: {
          badge: 'Администратор',
          title: 'Админка',
          subtitle: 'Управление безопасностью, конфигурацией и надежностью из одного места.',
          createUser: 'Создать сотрудника',
          createReport: 'Создать отчёт',
          lastUpdate: 'Последнее обновление: сегодня',
          access: 'Доступ: полный',
          dashboard: {
            overview: 'Обзор',
            orders: 'Заказы',
            users: 'Пользователи',
            comments: 'Комментарии',
            activeUsers: 'активных',
            hide: 'Скрыть',
            createEmployee: 'Создать сотрудника',
            promoCodes: 'Промокоды',
            banners: 'Баннеры',
            marketplace: 'Маркетплейс',
            publicFiles: 'Публичные файлы',
            deleteUser: 'Удалить пользователя',
            bannersTestingTitle: 'Функционал в тестировании',
            bannersTestingText: 'Раздел баннеров временно недоступен — функционал находится в тестировании.',
            notifications: 'Push-уведомления',
            stats: 'Статистика',
            kpi: {
              orders: 'Заказы',
              users: 'Пользователи',
              comments: 'Комментарии',
              dailyOrders: 'Заказов за день',
              weeklyOrders: 'Заказов за неделю',
              newUsers: 'Новых пользователей'
            },
            charts: {
              overview: 'Сводка',
              orders: 'Заказы',
              userStats: 'Пользователи',
              commentStats: 'Комментарии',
              weeklyOverview: 'Обзор за неделю',
              todayOrders: 'Заказы сегодня',
              categoryDistribution: 'Распределение по категориям'
            },
            days: {
              mon: 'Пн', tue: 'Вт', wed: 'Ср', thu: 'Чт', fri: 'Пт', sat: 'Сб', sun: 'Вс'
            }
          },
          period: {
            day: 'День',
            week: 'Неделя',
            month: 'Месяц',
            all: 'Все',
            dayShort: 'Д',
            weekShort: 'Н',
            monthShort: 'М',
            allShort: 'В'
          },
          categoryStats: {
            label: 'Статистика',
            title: 'Категории провайдеров',
            shortTitle: 'Категории',
            loading: 'Загрузка…',
            error: 'Не удалось загрузить статистику категорий',
            refresh: 'Обновить',
            total: 'Всего компаний',
            noData: 'Нет данных о категориях',
            noTitle: 'Без названия',
            companies: 'компаний',
            chartAria: 'Доля категорий по числу компаний',
            allCategories: 'Все категории',
            donutShortCount: '{{count}} компаний'
          },
          roles: {
            support: 'SUPPORT',
            supportDesc: 'Доступ к заказам и пользователям',
            admin: 'ADMIN',
            adminDesc: 'Полный доступ ко всем функциям'
          },
          form: {
            title: 'Создать сотрудника',
            newEmployee: 'Новый сотрудник',
            createAccount: 'Создание аккаунта',
            username: 'Имя пользователя',
            name: 'ФИО',
            namePlaceholder: 'Иван Иванов',
            email: 'Email',
            emailPlaceholder: 'ivan@example.com',
            phone: 'Телефон',
            phonePlaceholder: '+373 600 000 00',
            password: 'Пароль',
            role: 'РОЛЬ',
            submit: 'Создать сотрудника',
            submitting: 'Создание...',
            clear: 'Очистить',
            show: 'Показать',
            hide: 'Скрыть',
            optional: '(необязательно)',
            confirmTitle: 'Создать сотрудника?',
            confirmSubtitle: 'Проверьте данные перед отправкой на сервер.',
            confirmCancel: 'Отмена',
            confirmSubmit: 'Создать',
            notSpecified: 'не указан',
            createSuccess: 'Сотрудник успешно создан.',
            createError: 'Не удалось создать сотрудника',
            errorName: 'Укажите ФИО',
            errorPassword: 'Пароль не короче 6 символов',
            errorPhone: 'Укажите корректный номер телефона',
            errorEmailFormat: 'Некорректный формат email',
            errorRoleForbidden: 'Недостаточно прав для создания сотрудника с этой ролью'
          },
          promoCodes: {
            title: 'Промокоды',
            create: 'Создать промокод',
            cancelCreate: 'Скрыть форму',
            refresh: 'Обновить список',
            submit: 'Создать',
            submitting: 'Создание...',
            createSuccess: 'Промокод успешно создан.',
            createError: 'Не удалось создать промокод',
            loadError: 'Не удалось загрузить промокоды',
            updateError: 'Не удалось обновить промокод',
            empty: 'Промокодов пока нет',
            detailTitle: 'Детали промокода',
            code: 'Код',
            codePlaceholder: 'SUMMER2026',
            type: 'Тип',
            bonusAmount: 'Бонус',
            startsAt: 'Начало действия',
            expiresAt: 'Окончание',
            active: 'Статус',
            activeYes: 'Активен',
            activeNo: 'Неактивен',
            activate: 'Активировать',
            deactivate: 'Деактивировать',
            createdAt: 'Создан',
            saving: 'Сохранение...',
            errorCode: 'Укажите код промокода',
            errorBonus: 'Укажите корректную сумму бонуса (≥ 0)',
            errorDate: 'Укажите дату и время',
            types: {
              REGISTRATION: 'Регистрация',
              REFERRAL: 'Реферальный',
              MARKETING: 'Маркетинг',
              PARTNER: 'Партнёрский'
            },
            statsTitle: 'Статистика',
            totalUsed: 'Всего использований',
            activeUsersStat: 'Активных пользователей',
            activeUsersTitle: 'Активные пользователи',
            activeUsersEmpty: 'Нет активных пользователей',
            fullName: 'ФИО',
            role: 'Роль',
            ordersCount: 'Заказов',
            statsLoadError: 'Не удалось загрузить статистику',
            listSubtitle: 'Управление партнёрскими промокодами',
            searchPlaceholder: 'Поиск по коду...',
            clearSearch: 'Очистить поиск',
            searchEmpty: 'По вашему запросу ничего не найдено',
            resultsCount: 'Найдено: {{count}} из {{total}}',
            totalCount: 'Всего промокодов: {{count}}',
            backToList: 'К списку промокодов',
            settingsTitle: 'Настройки',
            editStatus: 'Изменить статус',
            confirm: {
              createTitle: 'Создать промокод?',
              createSubtitle: 'Проверьте данные перед созданием.',
              updateSubtitle: 'Проверьте изменения перед сохранением.',
              activateTitle: 'Активировать промокод?',
              deactivateTitle: 'Деактивировать промокод?',
              updateStartsAtTitle: 'Изменить дату начала?',
              updateExpiresAtTitle: 'Изменить дату окончания?',
              cancel: 'Отмена',
              confirm: 'Подтвердить',
              notSpecified: 'Не указано'
            }
          },
          newsBanners: {
            title: 'Новостные баннеры',
            listSubtitle: 'HTML-баннеры для клиентов и мастеров в приложении',
            create: 'Создать баннер',
            cancelCreate: 'Скрыть форму',
            refresh: 'Обновить список',
            submit: 'Создать баннер',
            submitting: 'Сохранение...',
            saveChanges: 'Сохранить изменения',
            deleting: 'Удаление...',
            createSuccess: 'Баннер успешно создан.',
            createError: 'Не удалось создать баннер',
            updateError: 'Не удалось обновить баннер',
            deleteError: 'Не удалось удалить баннер',
            loadError: 'Не удалось загрузить баннеры',
            empty: 'Баннеров пока нет',
            noText: 'Без текста',
            htmlContent: 'HTML-контент',
            htmlPlaceholder: '<div style="padding:16px">Текст вашего баннера</div>',
            preview: 'Предпросмотр',
            previewEmpty: 'Здесь появится предпросмотр баннера',
            zoom: {
              open: 'Открыть в увеличенном виде',
              in: 'Приблизить',
              out: 'Отдалить',
              reset: 'Сбросить масштаб',
              close: 'Закрыть'
            },
            startsAt: 'Начало показа',
            expiresAt: 'Окончание показа',
            registeredFrom: 'Регистрация от',
            registeredTo: 'Регистрация до',
            registeredHint: 'Баннер увидят только новые пользователи, зарегистрировавшиеся в этом периоде.',
            edit: 'Редактировать',
            delete: 'Удалить',
            editTitle: 'Редактировать баннер',
            editNote: 'HTML-контент изменить нельзя — обновите период показа и аудиторию.',
            statusLive: 'Активен',
            statusIdle: 'Не показывается',
            totalCount: 'Всего баннеров: {{count}}',
            audienceLabel: 'Аудитория',
            audience: {
              all: 'Все роли',
              customer: 'Клиенты',
              provider: 'Мастера',
              users: 'По списку ID',
              usersCount: '{{count}} польз.'
            },
            userIdsPlaceholder: 'UUID через запятую или с новой строки',
            userIdsHint: 'При указании списка баннер увидят только эти пользователи (роль игнорируется).',
            errorHtml: 'Укажите HTML-контент баннера',
            errorDateOrder: 'Дата окончания должна быть позже даты начала',
            errorRegisteredDateOrder: 'Дата "до" должна быть позже даты "от"',
            errorUsersRequired: 'Укажите хотя бы один ID пользователя',
            errorUsersInvalid: 'Некорректный формат ID: {{ids}}',
            confirm: {
              deleteTitle: 'Удалить баннер?',
              deleteSubtitle: 'Действие необратимо. Баннер перестанет показываться пользователям.',
              cancel: 'Отмена',
              delete: 'Удалить',
              notSpecified: 'Не указано'
            }
          },
          publicFiles: {
            title: 'Публичные файлы',
            listSubtitle: 'Публичные файлы для иконок сервисов маркетплейса и других нужд',
            upload: 'Загрузить файл',
            cancelUpload: 'Скрыть форму',
            refresh: 'Обновить список',
            submit: 'Загрузить',
            submitting: 'Загрузка...',
            uploadSuccess: 'Файл успешно загружен.',
            uploadError: 'Не удалось загрузить файл',
            loadError: 'Не удалось загрузить список файлов',
            empty: 'Файлов пока нет',
            file: 'Файл',
            fileHint: 'Изображение для публичного доступа (например, иконка сервиса в маркетплейсе).',
            preview: 'Превью',
            url: 'Ссылка',
            totalCount: 'Всего файлов: {{count}}',
            errorFileRequired: 'Выберите файл для загрузки',
            delete: 'Удалить',
            deleting: 'Удаление...',
            deleteError: 'Не удалось удалить файл',
            confirm: {
              deleteTitle: 'Удалить файл?',
              deleteSubtitle: 'Файл будет безвозвратно удалён из хранилища. Если он используется где-либо (например, как иконка сервиса), ссылка перестанет работать.',
              cancel: 'Отмена',
              delete: 'Удалить'
            }
          },
          deleteUser: {
            title: 'Удаление пользователя',
            subtitle: 'Найдите пользователя и удалите его аккаунт без возможности восстановления',
            warning: 'Удаление жёсткое: профиль и все связанные данные будут стёрты навсегда. Проверьте, что выбрали нужного пользователя.',
            searchPlaceholder: 'Имя, телефон или ID пользователя',
            clear: 'Очистить',
            hintName: 'Имя',
            hintPhone: 'Телефон',
            hintId: 'UUID профиля',
            emptyTitle: 'Начните поиск',
            emptyText: 'Введите имя, номер телефона или ID, чтобы найти пользователя для удаления.',
            noResults: 'Никого не нашли',
            noResultsText: 'Проверьте запрос — попробуйте полный номер телефона или UUID.',
            noName: 'Без имени',
            found: 'Показано {{shown}} из {{total}}',
            refineHint: 'Показаны не все совпадения — уточните запрос.',
            searchError: 'Не удалось выполнить поиск',
            delete: 'Удалить',
            deleting: 'Удаление...',
            deleteError: 'Не удалось удалить пользователя',
            deleteSuccess: 'Пользователь «{{name}}» удалён',
            confirm: {
              title: 'Удалить пользователя навсегда?',
              subtitle: 'Это действие нельзя отменить. Убедитесь, что удаляете правильный аккаунт.',
              consequenceProfile: 'Профиль и доступ к аккаунту будут удалены',
              consequenceData: 'Связанные данные пользователя будут стёрты',
              consequenceIrreversible: 'Восстановить аккаунт будет невозможно',
              acknowledge: 'Я понимаю, что удаление необратимо',
              cancel: 'Отмена',
              delete: 'Удалить навсегда'
            }
          },
          marketplace: {
            title: 'Маркетплейс',
            subtitle: 'Услуги маркетплейса для клиентов и статистика покупок',
            priceValue: '{{price}} MDL',
            tabs: {
              services: 'Сервисы',
              purchases: 'Покупки'
            },
            purchaseStatuses: {
              OPEN: 'Открыта',
              IN_PROGRESS: 'В работе',
              CLOSED: 'Закрыта'
            },
            services: {
              icon: 'Иконка',
              iconPlaceholder: '🧰 или https://...',
              iconHint: 'Emoji, текст или ссылка на изображение',
              serviceTitle: 'Название',
              serviceTitleLang: 'Название ({{lang}})',
              titlePlaceholder: 'Название сервиса',
              description: 'Описание',
              descriptionLang: 'Описание ({{lang}})',
              descriptionPlaceholder: 'Короткое описание сервиса',
              languages: {
                ro: 'Румынский',
                ru: 'Русский',
                en: 'Английский'
              },
              langHint: 'Название обязательно на всех трёх языках, описание — по желанию',
              price: 'Цена',
              pricePlaceholder: '100',
              createdAt: 'Создан',
              create: 'Создать сервис',
              cancelCreate: 'Скрыть форму',
              refresh: 'Обновить список',
              submit: 'Создать',
              submitting: 'Сохранение...',
              saveChanges: 'Сохранить изменения',
              deleting: 'Удаление...',
              edit: 'Редактировать',
              delete: 'Удалить',
              editTitle: 'Редактировать сервис',
              createSuccess: 'Сервис успешно создан.',
              createError: 'Не удалось создать сервис',
              updateError: 'Не удалось обновить сервис',
              deleteError: 'Не удалось удалить сервис',
              loadError: 'Не удалось загрузить сервисы',
              empty: 'Сервисов пока нет',
              noDescription: 'Без описания',
              totalCount: 'Всего сервисов: {{count}}',
              errorIcon: 'Укажите иконку сервиса',
              errorTitle: 'Укажите название сервиса',
              errorTitleLang: 'Укажите название сервиса на языке: {{lang}}',
              errorPrice: 'Укажите корректную цену (целое число больше 0)'
            },
            purchases: {
              refresh: 'Обновить',
              loadError: 'Не удалось загрузить покупки',
              empty: 'Покупок пока нет',
              totalLabel: 'Всего покупок',
              totalCount: 'Всего покупок: {{count}}',
              sort: 'Сортировка',
              sortByDate: 'По дате',
              sortByPrice: 'По цене',
              sortByStatus: 'По статусу',
              user: 'Пользователь',
              service: 'Сервис',
              price: 'Цена',
              status: 'Статус',
              createdAt: 'Дата покупки',
              changeStatus: 'Изменить статус',
              newStatus: 'Новый статус',
              saveStatus: 'Сохранить статус',
              statusError: 'Не удалось изменить статус покупки'
            },
            confirm: {
              cancel: 'Отмена',
              delete: 'Удалить',
              deleteTitle: 'Удалить сервис?',
              deleteSubtitle: 'Действие необратимо. Сервис исчезнет из маркетплейса.'
            }
          },
          transactions: {
            title: 'Транзакции',
            refresh: 'Обновить',
            totalCount: 'Всего транзакций: {{count}}',
            loadError: 'Не удалось загрузить транзакции',
            empty: 'Транзакций пока нет',
            amountValue: '{{amount}} MDL',
            filters: {
              userProfileId: 'ID пользователя',
              userProfileIdPlaceholder: 'UUID пользователя',
              orderId: 'ID заказа',
              orderIdPlaceholder: 'UUID заказа',
              type: 'Тип операции',
              allTypes: 'Все типы',
              typesSelected: 'Выбрано типов: {{count}}',
              createdFrom: 'Дата с',
              createdTo: 'Дата по'
            },
            summary: {
              totalCredit: 'Пополнения',
              totalDebit: 'Списания',
              net: 'Итого',
              byType: 'По типам операций'
            },
            table: {
              type: 'Тип',
              amount: 'Сумма',
              balanceAfter: 'Баланс после',
              userProfileId: 'Пользователь',
              orderId: 'Заказ',
              createdAt: 'Дата',
              openUser: 'Открыть профиль пользователя',
              openOrder: 'Открыть заказ'
            },
            types: {
              TOPUP_MODERATOR: 'Пополнение модератором',
              TOPUP_PACKAGE_PURCHASE: 'Покупка пакета',
              TOPUP_PACKAGE_PURCHASE_MIA: 'Покупка пакета (MIA)',
              FIRST_PACKAGE_BONUS: 'Бонус за первый пакет',
              REFERRAL_BONUS: 'Реферальный бонус',
              WITHDRAWAL_MODERATOR: 'Списание модератором',
              ORDER_PARTICIPATION: 'Участие в заказе',
              ORDER_PAYMENT: 'Оплата заказа'
            }
          },
          notifications: {
            badge: 'Уведомления',
            title: 'Отправка push-уведомлений',
            subtitle: 'Отправка push-уведомлений: всем пользователям, по фильтрам или по ID.',
            heroTitle: 'Push-уведомления',
            heroSubtitle: 'Сообщение для приложения: текст, аудитория и экран.',
            formLabel: 'Push-уведомление',
            formTitle: 'Создать и отправить',
            sectionContent: 'Текст и кому отправить',
            sectionTechnical: 'Технические параметры',
            titleField: 'Заголовок',
            titlePlaceholder: 'Заголовок уведомления',
            description: 'Описание',
            descriptionPlaceholder: 'Текст сообщения',
            imageUrl: 'Ссылка на изображение (необязательно)',
            language: 'Язык',
            targetType: 'Кому отправить',
            targetAll: 'Всем пользователям',
            targetUsers: 'Конкретным пользователям (по ID)',
            targetFilters: 'По фильтрам (роли / платформа)',
            byFilters: 'По фильтрам',
            byId: 'По ID',
            profileIds: 'ID профилей (через запятую)',
            targetRole: 'Роль получателя',
            recipient: {
              customer: 'Клиент',
              provider: 'Мастер'
            },
            screen: 'Экран при открытии',
            mediaAndLocale: 'Медиа и локализация',
            languageRu: 'Русский',
            languageRo: 'Română',
            languageEn: 'English',
            platform: 'Платформа',
            send: 'Отправить',
            sending: 'Отправка...',
            sent: 'Уведомление успешно отправлено!',
            sendError: 'Ошибка при отправке',
            sendResultStats: 'Всего: {{total}} · доставлено: {{success}} · с ошибкой: {{failure}}',
            mediaSection: 'Медиа',
            localeTabsLabel: 'Язык текста уведомления',
            languages: {
              ru: 'Русский',
              ro: 'Румынский',
              en: 'Английский'
            },
            failedTitle: 'Не доставлено ({{count}}):',
            copyIds: 'Копировать',
            copied: 'Скопировано',
            screens: {
              clientPending: 'Мои услуги в ожидании',
              clientActive: 'Мои услуги в работе',
              clientCompleted: 'Завершённые услуги',
              clientNewRequest: 'Новый запрос',
              clientNotifications: 'Уведомления',
              clientProfile: 'Профиль',
              clientSettings: 'Настройки',
              masterPurchased: 'Мои услуги купленные',
              masterActive: 'Мои услуги в работе',
              masterCompleted: 'Завершённые услуги',
              masterMarketplace: 'Маркетплейс',
              masterWallet: 'Кошелёк',
              masterCards: 'Мои карты',
              masterProfile: 'Мой профиль',
              masterPortfolio: 'Портфолио',
              masterReviews: 'Отзывы'
            },
            profileIdsPlaceholder: 'UUID, UUID...',
            imageUrlPlaceholder: 'https://...',
            saveToHistory: 'Сохранить уведомление в истории',
            saveToUserLabel: 'Сохранить у пользователя',
            saveToDbLabel: 'Сохранить в БД',
            confirm: {
              title: 'Подтвердить отправку',
              subtitle: 'Проверьте текст, фильтры и получателей перед отправкой.',
              send: 'Отправить',
              sectionMessage: 'Текст уведомления',
              sectionParams: 'Параметры доставки',
              badgeFilters: 'По фильтрам',
              badgeById: 'По ID',
              idsShowAll: 'Показать все',
              idsShowLess: 'Свернуть'
            },
            validation: {
              titleRequired: 'Заполните заголовок',
              descriptionRequired: 'Заполните текст сообщения',
              profileIdsRequired: 'Укажите хотя бы один ID профиля',
              platformRequired: 'Выберите хотя бы одну платформу (Android или iOS)'
            },
            schedule: {
              sectionTitle: 'Планирование',
              toggleNow: 'Отправить сейчас',
              toggleLater: 'Запланировать',
              submit: 'Запланировать',
              date: 'Дата',
              time: 'Время',
              add: 'Добавить',
              removeSlot: 'Убрать время',
              pickDateTime: 'Выберите дату и время',
              pastError: 'Нельзя запланировать на прошедшее время',
              duplicate: 'Это время уже добавлено',
              noSlots: 'Добавьте хотя бы одно время отправки',
              tzHint: 'Время указано по Кишинёву (Europe/Chisinau)',
              scheduledOk: 'Уведомление запланировано ({{count}})'
            },
            scheduledList: {
              title: 'Запланированные уведомления',
              refresh: 'Обновить',
              loading: 'Загрузка...',
              empty: 'Нет запланированных уведомлений',
              request: 'Данные запроса',
              cancel: 'Отменить',
              cancelling: 'Отмена...',
              cancelConfirm: 'Отменить это запланированное уведомление?',
              cancelled: 'Уведомление отменено',
              loadError: 'Не удалось загрузить список',
              cancelError: 'Не удалось отменить уведомление'
            }
          }
        },
        login: {
          title: 'Вход в систему',
          phone: 'Номер телефона',
          password: 'Пароль',
          role: 'Роль',
          selectRole: 'Выберите роль',
          submit: 'Войти',
          phonePlaceholder: '12345678',
          remember: 'Запомнить меня',
          showPassword: 'Показать пароль',
          hidePassword: 'Скрыть пароль'
        },
        home: {
          title: 'Главная',
          subtitle: 'Добро пожаловать в панель агента поддержки!',
          logs: {
            title: 'Системные логи',
            subtitle: 'Всего записей: {{count}}',
            loading: 'Загрузка логов...',
            emptyTitle: 'Логов не найдено',
            emptyText: 'Система не зафиксировала подходящих действий.',
            expand: 'Развернуть',
            collapse: 'Свернуть',
            reason: 'Причина',
            actor: 'Исполнитель',
            target: 'Объект',
            payload: 'Данные',
            filters: {
              actionContainsPlaceholder: 'Поиск по действию...',
              targetId: 'ID объекта',
              actorId: 'ID исполнителя',
              targetIdPlaceholder: 'Введите ID объекта...',
              actorIdPlaceholder: 'Введите ID исполнителя...',
              from: 'Дата от',
              to: 'Дата до',
              sortByCreatedDate: 'Дата создания'
            }
          },
          tabs: {
            system: 'Системные логи',
            orders: 'Логи ордеров',
            transactions: 'Транзакции'
          },
          orderLogs: {
            title: 'Логи модерации ордеров',
            subtitle: 'Всего записей: {{count}}',
            loading: 'Загрузка логов ордеров...',
            emptyTitle: 'Логи ордеров не найдены',
            emptyText: 'Пока нет записей модерации заказов.',
            untitled: 'Без названия',
            statusOk: 'OK',
            statusError: 'Ошибка',
            attempts: 'Попыток: {{count}}',
            description: 'Описание',
            aiError: 'Ошибка ИИ',
            user: 'Пользователь',
            createdAt: 'Создан',
            updatedAt: 'Обновлён',
            exportCsv: 'Экспорт CSV',
            exportAll: 'Экспорт всех (CSV)',
            exporting: 'Экспорт...',
            csvExportEmpty: 'Нет логов на текущей странице для экспорта',
            csvExportError: 'Не удалось экспортировать логи',
            filters: {
              sortByCreatedDate: 'Дата создания',
              sortByUpdatedDate: 'Дата обновления',
              sortByAttempts: 'Кол-во попыток',
              userId: 'ID пользователя',
              userIdPlaceholder: 'Введите ID пользователя...'
            }
          }
        },
        orders: {
          title: 'Заказы',
          loading: 'Загрузка заказов...',
          purchased: 'куплен',
          filters: {
            name: 'Название',
            namePlaceholder: 'Введите название заказа',
            allStatuses: 'Все статусы',
            sortButton: 'Сортировка',
            sortBy: 'Сортировать по',
            sortByDate: 'Дата обновления',
            sortByCreatedDate: 'Дата создания',
            id: 'ID заказчика',
            idPlaceholder: 'Введите ID...',
            sortDirection: 'Направление',
            descending: 'По убыванию',
            ascending: 'По возрастанию',
            extraFilters: 'Дополнительные фильтры',
            allLanguages: 'Все языки',
            languageRu: 'Русский',
            languageEn: 'Английский',
            languageRo: 'Румынский',
            neverBought: 'Не куплен',
            allPurchaseStatuses: 'Все заказы',
            dateFrom: 'Дата от',
            dateTo: 'Дата до',
            statusDatesTitle: 'Дата смены статуса',
            statusDates: {
              IN_WORK: 'В работе',
              DONE: 'Выполнен',
              CANCELED: 'Отменён'
            }
          },
          statusLabels: {
            IN_PROGRESS: 'в процессе',
            IN_WORK: 'В работе',
            DONE: 'Завершен',
            DONE_DELETED: 'Завершен (удалён клиентом)',
            CANCELED: 'Отменен',
            BLOCKED: 'заблокирован',
            UNKNOWN: 'Неизвестно'
          },
          empty: {
            title: 'Заказы не найдены',
            subtitle: 'Попробуйте изменить параметры поиска'
          },
          exportCsv: 'Экспорт CSV',
          exportAll: 'Экспорт всех (CSV)',
          exporting: 'Экспорт...',
          csvExportEmpty: 'Нет заказов на текущей странице для экспорта'
        },
        users: {
          title: 'Пользователи',
          loading: 'Загрузка пользователей...',
          filters: {
            allRoles: 'Все роли',
            allStatuses: 'Все статусы',
            namePlaceholder: 'Введите имя...',
            phone: 'Телефон',
            phonePlaceholder: 'Введите номер...',
            role: 'Роль',
            status: 'Статус',
            verification: 'Верификация',
            allVerification: 'Любая верификация',
            verifiedOnly: 'Только верифицированные',
            notVerifiedOnly: 'Только не верифицированные',
            marketingConsent: 'Согласие на рассылку',
            allMarketingConsent: 'Любое согласие',
            marketingConsentYes: 'Согласны на рассылку',
            marketingConsentNo: 'Без согласия',
            dateFrom: 'Дата от',
            dateTo: 'Дата до',
            ratingFrom: 'Рейтинг от',
            ratingTo: 'Рейтинг до',
            ratingRangeShortFrom: 'От',
            ratingRangeShortTo: 'До',
            ordersCount: 'Количество заказов',
            ordersCountPlaceholder: 'Например, 5',
            ordersCountOrMore: 'и более',
            sortButton: 'Сортировка',
            sortBy: 'Сортировать по',
            id: 'ID пользователя',
            idPlaceholder: 'Введите ID...',
            sortByFullName: 'По имени',
            sortByRating: 'По рейтингу',
            sortByDate: 'Дата обновления',
            sortByCreatedDate: 'Дата создания',
            descending: 'По убыванию',
            ascending: 'По возрастанию',
            sortDirection: 'Направление',
            providerCategories: 'Категории провайдера',
            providerCategoriesHint: 'Можно выбрать одну категорию — в списке останутся провайдеры с этой категорией.',
            categoriesSearchPlaceholder: 'Поиск по названию категории...',
            categoriesLoading: 'Загрузка категорий...',
            categoriesEmpty: 'Нет категорий по запросу',
            categoriesError: 'Не удалось загрузить категории',
            categoriesClearSelected: 'Сбросить категории',
            categoriesRemoveChip: 'Убрать категорию',
            regions: 'Регионы компаний',
            regionsHint: 'Можно выбрать несколько регионов — в списке останутся пользователи с компаниями из этих регионов.',
            regionsSearchPlaceholder: 'Поиск региона по названию...',
            regionsLoading: 'Загрузка регионов...',
            regionsEmpty: 'Регионы не найдены',
            regionsError: 'Не удалось загрузить регионы',
            regionsClearSelected: 'Сбросить регионы',
            regionsRemoveChip: 'Убрать регион'
          },
          roles: {
            CUSTOMER: 'Клиент',
            PROVIDER: 'Мастер',
            SUPPORT: 'Поддержка',
            MODERATOR: 'Модератор',
            ADMIN: 'Администратор',
            DEV: 'Разработчик',
            CLIENT: 'Клиент',
            EMPLOYEE: 'Сотрудник'
          },
          statuses: {
            ACTIVE: 'Активный',
            INACTIVE: 'Неактивный',
            BLOCKED: 'Заблокирован'
          },
          plans: {
            BASIC: 'Базовый',
            PREMIUM: 'Премиум',
            PRO: 'Про',
            basic: 'Базовый'
          },
          labels: {
            reviews: 'отзывов',
            orders: 'заказов',
            notProvided: 'Не указано',
            verified: 'Верифицирован',
            notVerified: 'Не верифицирован'
          },
          empty: {
            title: 'Пользователи не найдены',
            subtitle: 'Попробуйте изменить параметры фильтрации'
          },
          exportCsv: 'Экспорт CSV',
          exportAll: 'Экспорт всех (CSV)',
          exporting: 'Экспорт...',
          csvExportEmpty: 'Нет пользователей на текущей странице для экспорта',
          adminExportCsv: 'Админ-экспорт (CSV)',
          adminExportAllCsv: 'Админ-экспорт всех (CSV)',
          adminExporting: 'Экспорт...',
          actions: {
            button: 'Действия',
            generateReport: 'Сформировать отчёт',
            generateReportHint: 'Полный набор полей, включая заказы и платежи',
            exportData: 'Экспорт данных',
            exportDataHint: 'ID, имя и телефон в CSV',
            adminBadge: 'Админ',
            back: 'Назад',
            audienceTitle: 'Кого выгрузить?',
            audienceAll: 'Все пользователи',
            audienceAllHint: 'По текущим фильтрам поиска',
            audienceMarketing: 'Только для рассылки',
            audienceMarketingHint: 'Текущие фильтры + согласие на рассылку',
            preparing: 'Готовим файл...',
            empty: 'Нет пользователей для выгрузки',
            failed: 'Не удалось выгрузить пользователей'
          }
        },
        complaints: {
          title: 'Жалобы',
          loading: 'Загрузка жалоб...',
          filters: {
            allStatuses: 'Все статусы'
          },
          empty: {
            title: 'Жалоб не найдено',
            subtitle: 'По вашему запросу ничего не найдено.'
          },
          statuses: {
            PENDING: 'В ожидании',
            IN_REVIEW: 'На рассмотрении',
            RESOLVED: 'Решена',
            REJECTED: 'Отклонена'
          },
          targetTypes: {
            USER: 'Пользователь',
            COMMENT: 'Комментарий',
            ORDER: 'Заказ'
          },
          filters: {
            allTypes: 'Все типы',
            searchPlaceholder: 'Поиск по ID или описанию...'
          },
          labels: {
            reporterId: 'Отправитель'
          }
        },
        orderDetails: {
          title: 'Заявка',
          loading: 'Загрузка...',
          error: 'Ошибка загрузки заказа',
          notFound: 'Заявка не найдена',
          missing: 'Заявка с ID {{id}} не найдена',
          status: {
            inWork: 'В работе'
          },
          sections: {
            main: 'Основная информация',
            customer: 'Заказчик',
            companiesLabel: 'Компании',
            executingCompany: 'Компания, выполняющая заказ'
          },
          fields: {
            category: 'Категория',
            description: 'Описание',
            price: 'Стоимость',
            tags: 'Теги:'
          },
          address: {
            title: 'Адрес заказа'
          },
          timeline: {
            title: 'Хронология',
            startDate: 'Дата начала',
            createdAt: 'Дата создания',
            updatedAt: 'Дата обновления'
          },
          photos: {
            title: 'Фото заявки'
          },
          companies: {
            empty: 'Компаний не найдено'
          },
          changeStatus: 'Изменить статус',
          selectStatusPlaceholder: 'Выберите статус',
          confirmStatusChange: 'Изменить статус заказа на «{{status}}»?',
          tabs: {
            main: 'Основная информация',
            interaction: 'Взаимодействие'
          },
          summary: {
            title: 'Сводка заказа'
          },
          interaction: {
            statusTitle: 'Статус заказа',
            masterLabel: 'Компания, закреплённая за заказом',
            masterPlaceholder: 'Выберите компанию',
            masterRequired: 'Выберите компанию перед изменением статуса',
            noteTitle: 'Заметки поддержки по заказу',
            notePlaceholder: 'Добавьте внутреннюю заметку для команды саппорта об этом заказе...',
            clear: 'Очистить',
            save: 'Сохранить',
            deleteConfirm: 'Удалить эту заметку?'
          }
        },
        complaintDetails: {
          title: 'Жалоба #{{id}}',
          error: 'Ошибка загрузки жалобы',
          notFound: 'Жалоба не найдена',
          changeStatus: 'Изменить статус',
          selectStatusPlaceholder: 'Выберите статус',
          mainInfo: 'Основная информация',
          description: 'Описание жалобы',
          reviewTitle: 'Комментарий',
          reviewError: 'Ошибка загрузки отзыва',
          metadata: 'Метаданные',
          labels: {
            type: 'ТИП ОБЪЕКТА',
            reporterId: 'ID РЕПОРТЕРА',
            targetId: 'ID ОБЪЕКТА',
            createdAt: 'ДАТА СОЗДАНИЯ',
            updatedAt: 'ДАТА ОБНОВЛЕНИЯ'
          },
          reviewButtons: {
            viewReviewer: 'Автор комментария',
            viewReviewed: 'Чей профиль'
          }
        },
        userDetails: {
          title: 'Профиль пользователя',
          loading: 'Загрузка...',
          edit: 'Редактировать',
          editUser: 'Редактировать пользователя',
          contact: 'Контакты',
          personal: 'Личные данные',
          business: 'Бизнес',
          system: 'Системная информация',
          tabs: {
            profile: 'Профиль',
            reviews: 'Отзывы ({{count}})',
            orders: 'Купленные заказы',
            clientOrders: 'Заказы ({{count}})',
            interaction: 'Взаимодействие'
          },
          statusActions: {
            change: 'Изменить',
            changeTitle: 'Изменить статус',
            blockAction: 'Заблокировать',
            blockQuestion: 'Заблокировать пользователя {{name}}?',
            unblockAction: 'Разблокировать',
            unblockQuestion: 'Разблокировать пользователя {{name}}?',
            deactivateAction: 'Деактивировать',
            statusChangeQuestion: 'Изменить статус пользователя {{name}} на "{{status}}"?'
          },
          labels: {
            fullName: 'ФИО',
            role: 'Роль',
            verified: 'Верификация',
            balance: 'Баланс',
            marketplaceBalance: 'Баланс маркетплейса',
            inDebt: 'В долгу',
            phone: 'Телефон',
            email: 'Email',
            address: 'Адрес',
            dateOfBirth: 'Дата рождения',
            gender: 'Пол',
            language: 'Язык',
            company: 'Компания',
            companyRating: 'Рейтинг компании',
            referralCode: 'Реф. код',
            referrals: 'Рефералы',
            referralsPeriod: 'За период',
            userId: 'User ID',
            created: 'Создан',
            updated: 'Обновлен',
            debtStartedAt: 'Долг с',
            marketingConsent: 'Рассылка',
            marketingConsentAt: 'Дата согласия',
            marketingAgreed: 'Согласен',
            marketingDeclined: 'Отказался',
            marketingNoAnswer: 'Нет ответа'
          },
          balance: {
            edit: 'Изм. баланс',
            title: 'Изменение баланса',
            currentBalance: 'Текущий баланс',
            actionType: 'Тип операции',
            add: 'Начислить',
            subtract: 'Списать',
            subtracting: 'Списание',
            adding: 'Пополнение',
            amount: 'Сумма',
            reason: 'Причина',
            reasonPlaceholder: 'Укажите причину изменения баланса...',
            current: 'Текущий',
            resulting: 'Итоговый',
            confirm: 'Подтвердить',
            confirmTitle: 'Подтверждение операции',
            opType: 'Операция',
            success: 'Баланс успешно изменен',
            error: 'Ошибка изменения баланса',
            debtJustNow: 'только что',
            errors: {
              amountInvalid: 'Сумма должна быть не менее 1',
              amountTooLarge: 'Сумма не может превышать {{max}} MDL',
              balanceExceedsMax: 'После операции баланс превысит {{max}} MDL',
              insufficientBalance: 'Недостаточно средств на балансе',
              reasonRequired: 'Причина обязательна для заполнения'
            }
          },
          company: {
            title: 'Портфолио',
            loading: 'Загрузка данных...',
            name: 'Название',
            rating: 'Рейтинг',
            languages: 'Языки',
            openToUrgent: 'Срочные заказы',
            minimumCallOutPrice: 'Мин. цена',
            workInfo: 'Работа',
            teamSize: 'Команда',
            team: 'Работает в команде',
            schedule: 'Расписание',
            about: 'О компании',
            description: 'Описание',
            bio: 'Биография',
            categories: 'Категории',
            regions: 'Регионы',
            services: 'Услуги',
            documents: 'Документы',
            photos: 'Фото',
            categoryFallback: 'Категория {{index}}',
            serviceFallback: 'Услуга {{index}}',
            documentFallback: 'Документ {{index}}',
            photoFallback: 'Фото {{index}}'
          },
          modal: {
            cancel: 'Отмена',
            save: 'Сохранить',
            editUserTitle: 'Редактировать пользователя',
            status: 'Статус',
            plan: 'Тариф',
            selectGender: 'Выберите пол',
            selectLanguage: 'Выберите язык',
            selectPlan: 'Выберите тариф',
            male: 'Мужской',
            female: 'Женский',
            fullNamePlaceholder: 'Введите полное имя',
            emailPlaceholder: 'Введите email',
            referralCodePlaceholder: 'Введите реферальный код'
          },
          messages: {
            copied: 'Скопировано!',
            userUpdated: 'Данные пользователя обновлены',
            userUpdateError: 'Ошибка обновления данных',
            statusUpdateError: 'Ошибка изменения статуса',
            noteSaved: 'Заметка сохранена',
            reviewSaved: 'Отзыв опубликован'
          },
          reviews: {
            title: 'Отзывы',
            refresh: 'Обновить',
            deleteConfirm: 'Удалить этот отзыв?',
            deleteSuccess: 'Отзыв удален',
            deleteError: 'Ошибка при удалении',
            loadError: 'Ошибка загрузки отзывов',
            emptyTitle: 'Отзывов пока нет',
            emptyText: 'У этого пользователя еще нет отзывов',
            noRating: 'Нет оценки',
            noComment: 'Без комментария',
            viewProfile: 'Профиль',
            deleting: 'Удаление...',
            delete: 'Удалить'
          },
          orders: {
            title: 'Купленные заказы',
            clientTitle: 'Заказы клиента',
            sortBy: 'Сортировка по',
            sortByCreated: 'Дате создания',
            sortByUpdated: 'Дате обновления',
            sortDesc: 'По убыванию',
            sortAsc: 'По возрастанию',
            loading: 'Загрузка заказов...',
            loadError: 'Ошибка загрузки заказов',
            view: 'Просмотр',
            emptyTitle: 'Нет купленных заказов',
            emptyText: 'У этого провайдера пока нет купленных заказов',
            clientEmptyTitle: 'Заказов пока нет',
            clientEmptyText: 'У этого пользователя пока нет заказов',
            table: {
              id: 'ID заказа',
              title: 'Название',
              status: 'Статус',
              accepted: 'Принят',
              createdAt: 'Создан',
              updatedAt: 'Обновлен',
              actions: 'Действия'
            }
          },
          schedule: {
            monday: 'Понедельник',
            tuesday: 'Вторник',
            wednesday: 'Среда',
            thursday: 'Четверг',
            friday: 'Пятница',
            saturday: 'Суббота',
            sunday: 'Воскресенье',
            dayOff: 'Выходной',
            flexible: 'Гибкий график',
            notConfigured: 'Расписание не настроено'
          },
          verification: {
            title: 'Верификация компании',
            verified: 'Компания верифицирована',
            notVerified: 'Компания не верифицирована',
            verifyAction: 'Верифицировать',
            unverifyAction: 'Снять верификацию',
            successVerified: 'Компания верифицирована',
            successUnverified: 'Верификация компании снята',
            error: 'Ошибка изменения верификации: {{error}}'
          },
          interaction: {
            statusTitle: 'Статус пользователя',
            statusSub: 'Управляйте доступом пользователя к платформе',
            noteTitle: 'Заметки поддержки',
            noteSub: 'Внутренние заметки видны только команде',
            notePlaceholder: 'Добавьте заметку о взаимодействии с пользователем...',
            clear: 'Очистить',
            save: 'Сохранить',
            deleteConfirm: 'Удалить эту заметку?',
            review: {
              title: 'Оставить отзыв мастеру',
              subtitle: 'Опубликуйте официальный отзыв от имени выбранного аккаунта',
              ratingLabel: 'Оценка',
              reviewerLabel: 'ID аккаунта, от которого оставляется отзыв',
              commentLabel: 'Комментарий',
              commentPlaceholder: 'Опишите качество работы мастера...',
              submit: 'Опубликовать отзыв',
              invalidReviewer: 'Укажите корректный ID аккаунта (UUID)'
            }
          }
        }
      }
    },
    en: {
      translation: {
        homepage: {
          badge: 'TeSalut support workspace',
          greeting: {
            morning: 'Good morning',
            day: 'Good afternoon',
            evening: 'Good evening',
            night: 'Good night'
          },
          titleLead: 'TeSalut support\u00A0—',
          titleAccent: 'fast and all in one place',
          lead: 'Orders, users, complaints and logs are always at hand. Resolve requests, manage customer and provider profiles and stay in touch with the team without switching between tools.',
          ctaPrimary: 'Go to orders',
          ctaSecondary: 'Find a user',
          role: 'Your role',
          stats: {
            users: 'Users',
            usersHint: 'Total in the system',
            newUsers: 'New today',
            newUsersHint: 'Signed up since midnight',
            orders: 'Orders',
            ordersHint: 'All time',
            complaints: 'Open complaints',
            complaintsHint: 'Awaiting review',
            unavailable: 'No data'
          },
          sections: {
            badge: 'Sections',
            title: 'Where do we start today?',
            subtitle: 'Only the sections available to your role are shown here.',
            open: 'Open',
            orders: 'Order search, statuses, participants and change history.',
            users: 'Customer and provider profiles: balance, reviews, support comments.',
            complaints: 'Review complaints about users, orders and comments.',
            chat: 'Team messaging: direct chats, groups, files and voice notes.',
            calendar: 'Team schedule: shifts, releases and meetings.',
            logs: 'System logs and the order moderation journal.',
            statistics: 'Charts for users, orders and reviews over any period.',
            admin: 'Promo codes, push campaigns, marketplace, banners and staff.'
          },
          tips: {
            badge: 'Tips',
            title: 'Work faster',
            subtitle: 'A few tricks that save time in everyday work.',
            searchTitle: 'Search by ID',
            searchText: 'Paste a full UUID into the filter and the profile opens right away, no paging needed.',
            exportTitle: 'Mailing list export',
            exportText: 'The Actions menu on the users page exports only those who opted in to mailing.',
            themeTitle: 'Light and dark theme',
            themeText: 'Toggle it in the top bar, your choice is remembered.',
            languageTitle: 'Three languages',
            languageText: 'Русский, English and Română, switch the language in the top bar.'
          }
        },
        devNotice: {
          title: 'Page under development',
          text: 'This section is still being built: the data comes from a test set and may be inaccurate. Nothing you change here is saved to the server yet.',
          button: 'Got it'
        },
        chat: {
          title: 'Chat',
          subtitle: 'Messaging with users and the team',
          connection: {
            connecting: 'Connecting to chat...',
            reconnecting: 'Reconnecting to chat...',
            failed: 'Realtime connection is unavailable — messages are sent and received over regular requests',
            retry: 'Retry'
          },
          errors: {
            history: 'Failed to load message history',
            generic: 'Chat error'
          },
          list: {
            title: 'Messages',
            searchPlaceholder: 'Search chats',
            empty: 'No chats yet',
            notFound: 'Nothing found',
            newChat: 'Message someone new',
            newGroup: 'New group',
            writeToEmployee: 'Message a colleague',
            createGroup: 'Create a group',
            unpin: 'Unpin',
            unmute: 'Enable notifications'
          },
          window: {
            empty: 'Pick a chat to start the conversation',
            activeNow: 'Active now',
            typing: 'typing…',
            typingNamed: '{{name}} is typing…',
            members: '{{count}} members',
            offline: 'offline',
            offlineHint: 'No connection — messages go over regular requests',
            actions: 'Actions',
            pin: 'Pin',
            unpin: 'Unpin',
            mute: 'Mute notifications',
            unmute: 'Enable notifications',
            rename: 'Rename group',
            save: 'Save',
            participants: 'Group members'
          },
          composer: {
            placeholder: 'Write a message...',
            placeholderNamed: 'Message {{name}}...',
            attach: 'Attach a file',
            emoji: 'Emoji',
            voice: 'Record a voice message',
            send: 'Send',
            cancelReply: 'Cancel reply',
            uploadError: 'Failed to upload the file',
            voiceError: 'Failed to send the voice message',
            recordCancel: 'Cancel',
            recordSend: 'Send voice message'
          },
          message: {
            reply: 'Reply',
            react: 'React',
            image: 'Image'
          },
          preview: {
            photo: 'Photo',
            voice: 'Voice message',
            file: 'File'
          },
          system: {
            memberAdded: '{{author}} added {{member}}',
            memberRemoved: '{{author}} removed {{member}}',
            memberLeft: '{{member}} left the group',
            titleChanged: '{{author}} renamed the group to “{{title}}”',
            unknown: 'Member'
          },
          date: {
            today: 'Today',
            yesterday: 'Yesterday'
          },
          fallback: {
            group: 'Group',
            order: 'Order {{id}}',
            user: 'User {{id}}',
            chat: 'Chat'
          },
          participants: {
            title: 'Members',
            count: '{{count}} people',
            add: 'Add members',
            remove: 'Remove from group',
            you: 'you',
            leave: 'Leave group',
            leaveConfirm: 'Leave the group?',
            leaveCancel: 'Cancel',
            leaveAction: 'Leave',
            leaving: 'Leaving...',
            removeError: 'Failed to remove the member',
            leaveError: 'Failed to leave the group',
            roles: {
              OWNER: 'Owner',
              ADMIN: 'Admin'
            }
          },
          picker: {
            directTitle: 'New chat',
            directSub: 'Search a colleague by name',
            groupTitle: 'New group',
            groupSub: 'Title and members',
            addTitle: 'Add members',
            addSub: 'People already in the group are hidden',
            namePlaceholder: 'Group title',
            searchPlaceholder: 'Type a name...',
            allRoles: 'All roles',
            notFound: 'Nobody found',
            selected: '{{count}} selected',
            selectedMin: '{{count}} selected, at least {{min}} required',
            create: 'Create group',
            add: 'Add',
            saving: 'Saving...',
            loadError: 'Failed to load the staff list',
            actionError: 'Action failed',
            openChatError: 'Failed to open a chat with this user',
            roles: {
              SUPPORT: 'Support',
              MODERATOR: 'Moderator',
              ADMIN: 'Admin',
              DEV: 'Developer'
            }
          }
        },
        calendar: {
          title: 'Calendar',
          subtitle: 'Team schedule and admin events',
          newEvent: 'New event',
          newCalendar: 'New calendar',
          today: 'Today',
          prev: 'Previous',
          next: 'Next',
          searchPlaceholder: 'Search events...',
          views: {
            month: 'Month',
            list: 'List'
          },
          more: '{{count}} more',
          agendaEmpty: 'No events',
          dialog: {
            createTitle: 'New event',
            createSub: 'Add an event to the calendar',
            editTitle: 'Event',
            editSub: 'Edit the calendar event',
            name: 'Title',
            namePlaceholder: 'Enter the event title...',
            calendar: 'Calendar',
            date: 'Date',
            time: 'Time',
            duration: 'Duration',
            options: 'Options',
            allDay: 'All day',
            reminder: 'Reminder',
            location: 'Location',
            locationPlaceholder: 'Meeting room, call link...',
            attendees: 'Attendees',
            attendeePlaceholder: 'Add an attendee...',
            add: 'Add',
            description: 'Description',
            descriptionPlaceholder: 'Add a description...',
            create: 'Create event',
            save: 'Save',
            cancel: 'Cancel',
            delete: 'Delete',
            close: 'Close',
            durations: {
              '15': '15 min',
              '30': '30 min',
              '45': '45 min',
              '60': '1 hour',
              '90': '1.5 hours',
              '120': '2 hours',
              '180': '3 hours',
              '1440': 'All day'
            }
          }
        },
        statistics: {
          title: 'Statistics',
          subtitle: 'Service performance and key metrics in real time',
          newReport: 'New report',
          actions: 'Actions',
          export: 'Export',
          sales: {
            title: 'Sales performance',
            subtitle: 'Monthly sales vs target',
            sales: 'Sales',
            target: 'Target'
          },
          revenue: {
            title: 'Revenue breakdown',
            subtitle: 'Distribution by source'
          },
          transactions: {
            title: 'Recent transactions',
            subtitle: 'Latest customer operations',
            viewAll: 'View all'
          },
          products: {
            title: 'Top services',
            subtitle: 'Best performers this month',
            viewAll: 'View all',
            sales: '{{count}} sales',
            stock: 'Stock: {{count}}'
          },
          insights: {
            title: 'Customer insights',
            subtitle: 'Growth trends and demographics',
            tabs: {
              growth: 'Growth',
              demographics: 'Demographics',
              regions: 'Regions'
            },
            growthTitle: 'Customer growth trends',
            ageTitle: 'Age groups',
            regionsTitle: 'Distribution by region',
            keyMetrics: 'Key metrics',
            series: {
              new: 'New',
              returning: 'Returning',
              churned: 'Churned'
            }
          }
        },
        common: {
          language: 'Language',
          loading: 'Loading...',
          saved: 'Saved!',
          notFound: 'Page not found',
          error: 'Error',
          back: 'Back',
          backToList: 'Back to list',
          view: 'View details',
          search: 'Search',
          searchLoading: 'Searching...',
          clear: 'Clear',
          reset: 'Reset',
          save: 'Save',
          cancel: 'Cancel',
          close: 'Close',
          yes: 'Yes',
          no: 'No',
          page: 'Page {{page}}',
          total: '{{count}} total',
          status: 'Status',
          ms: 'ms',
          copy: 'Copy',
          copied: 'Copied!',
          notProvided: 'Not provided',
          actions: 'Actions',
          description: 'Description',
          createdAt: 'Created at',
          updatedAt: 'Updated at',
          pagination: {
            showing: 'Showing {{from}} - {{to}} of {{total}}',
            previous: 'Prev',
            next: 'Next',
            page: 'Page {{page}}',
            pageOf: 'Page {{page}} of {{total}}',
            itemsPerPage: 'Items per page',
            noResults: 'No results',
            items: 'items'
          },
          houseShort: 'hse.',
          apartmentShort: 'apt.',
          datePicker: {
            placeholderDateTime: 'DD.MM.YYYY HH:MM',
            placeholderDate: 'DD.MM.YYYY',
            increase: 'Increase',
            decrease: 'Decrease',
            clear: 'Clear',
            hourLetter: 'h',
            minuteLetter: 'm',
            ok: 'OK',
            now: 'Now',
            time: 'Time',
            date: 'Date'
          },
          next: 'Next'
        },
        imageViewer: {
          title: 'Image preview',
          prev: 'Previous',
          next: 'Next',
          zoomIn: 'Zoom in',
          zoomOut: 'Zoom out',
          loadError: 'Failed to load image',
          avatar: 'User avatar',
          openAvatar: 'Open avatar',
          showMore: '{{n}} more',
          showLess: 'Show less'
        },
        nav: {
          sections: {
            workspace: 'Workspace',
            tools: 'Tools',
            admin: 'Administration'
          },
          searchTitle: 'What do you need?',
          searchPlaceholder: 'Search sections...',
          openMenu: 'Open menu',
          collapse: 'Collapse menu',
          expand: 'Expand menu',
          logo: 'SalutApp Admin',
          home: 'Home',
          logs: 'Logs',
          orders: 'Orders',
          users: 'Users',
          complaints: 'Complaints',
          chat: 'Chat',
          statistics: 'Statistics',
          calendar: 'Calendar',
          tools: 'Tools',
          chatHint: 'Team messaging',
          statisticsHint: 'Service metrics',
          calendarHint: 'Schedule and events',
          admin: 'Admin',
          logout: 'Logout',
          userFallback: 'User',
          languageSwitcher: 'Language',
          theme: {
            switchToDark: 'Dark theme',
            switchToLight: 'Light theme'
          }
        },
        footer: {
          copyright: '© {{year}} COOLCHAS COMMUNITY SRL – TeSalut. All rights reserved'
        },
        admin: {
          badge: 'Administrator',
          title: 'Admin Panel',
          subtitle: 'Manage security, configuration, and reliability from one place.',
          createUser: 'Create Employee',
          createReport: 'Create Report',
          lastUpdate: 'Last update: today',
          access: 'Access: full',
          dashboard: {
            overview: 'Overview',
            orders: 'Orders',
            users: 'Users',
            comments: 'Comments',
            activeUsers: 'Active',
            hide: 'Hide',
            createEmployee: 'Create Employee',
            promoCodes: 'Promo Codes',
            banners: 'Banners',
            marketplace: 'Marketplace',
            publicFiles: 'Public Files',
            deleteUser: 'Delete User',
            bannersTestingTitle: 'Feature under testing',
            bannersTestingText: 'The banners section is temporarily unavailable — the feature is currently under testing.',
            notifications: 'Push Notifications',
            stats: 'Statistics',
            kpi: {
              orders: 'Orders',
              users: 'Users',
              comments: 'Comments',
              dailyOrders: 'Daily Orders',
              weeklyOrders: 'Weekly Orders',
              newUsers: 'New Users'
            },
            charts: {
              overview: 'Summary',
              orders: 'Orders',
              userStats: 'Users',
              commentStats: 'Comments',
              weeklyOverview: 'Weekly Overview',
              todayOrders: 'Orders Today',
              categoryDistribution: 'Category Distribution'
            },
            days: {
              mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat', sun: 'Sun'
            }
          },
          period: {
            day: 'Day',
            week: 'Week',
            month: 'Month',
            all: 'All',
            dayShort: 'D',
            weekShort: 'W',
            monthShort: 'M',
            allShort: 'A'
          },
          categoryStats: {
            label: 'Statistics',
            title: 'Provider categories',
            shortTitle: 'Categories',
            loading: 'Loading…',
            error: 'Failed to load category statistics',
            refresh: 'Refresh',
            total: 'Companies total',
            noData: 'No category data',
            noTitle: 'No title',
            companies: 'companies',
            chartAria: 'Share of categories by company count',
            allCategories: 'All categories',
            donutShortCount: '{{count}} companies'
          },
          roles: {
            support: 'SUPPORT',
            supportDesc: 'Access to orders and users',
            admin: 'ADMIN',
            adminDesc: 'Full access to all functions'
          },
          form: {
            title: 'Create Employee',
            newEmployee: 'New Employee',
            createAccount: 'Account Creation',
            username: 'Username',
            name: 'Full Name',
            namePlaceholder: 'John Doe',
            email: 'Email',
            emailPlaceholder: 'john@example.com',
            phone: 'Phone',
            phonePlaceholder: '+373 600 000 00',
            password: 'Password',
            role: 'ROLE',
            submit: 'Create Employee',
            submitting: 'Creating...',
            clear: 'Clear',
            show: 'Show',
            hide: 'Hide',
            optional: '(optional)',
            confirmTitle: 'Create employee?',
            confirmSubtitle: 'Review the details before submitting to the server.',
            confirmCancel: 'Cancel',
            confirmSubmit: 'Create',
            notSpecified: 'not specified',
            createSuccess: 'Employee created successfully.',
            createError: 'Failed to create employee',
            errorName: 'Enter full name',
            errorPassword: 'Password must be at least 6 characters',
            errorPhone: 'Enter a valid phone number',
            errorEmailFormat: 'Invalid email format',
            errorRoleForbidden: 'You do not have permission to create an employee with this role'
          },
          promoCodes: {
            title: 'Promo Codes',
            create: 'Create promo code',
            cancelCreate: 'Hide form',
            refresh: 'Refresh list',
            submit: 'Create',
            submitting: 'Creating...',
            createSuccess: 'Promo code created successfully.',
            createError: 'Failed to create promo code',
            loadError: 'Failed to load promo codes',
            updateError: 'Failed to update promo code',
            empty: 'No promo codes yet',
            detailTitle: 'Promo code details',
            code: 'Code',
            codePlaceholder: 'SUMMER2026',
            type: 'Type',
            bonusAmount: 'Bonus',
            startsAt: 'Starts at',
            expiresAt: 'Expires at',
            active: 'Status',
            activeYes: 'Active',
            activeNo: 'Inactive',
            activate: 'Activate',
            deactivate: 'Deactivate',
            createdAt: 'Created',
            saving: 'Saving...',
            errorCode: 'Enter promo code',
            errorBonus: 'Enter a valid bonus amount (≥ 0)',
            errorDate: 'Enter date and time',
            types: {
              REGISTRATION: 'Registration',
              REFERRAL: 'Referral',
              MARKETING: 'Marketing',
              PARTNER: 'Partner'
            },
            statsTitle: 'Statistics',
            totalUsed: 'Total uses',
            activeUsersStat: 'Active users',
            activeUsersTitle: 'Active users',
            activeUsersEmpty: 'No active users',
            fullName: 'Full name',
            role: 'Role',
            ordersCount: 'Orders',
            statsLoadError: 'Failed to load statistics',
            listSubtitle: 'Manage partner promo codes',
            searchPlaceholder: 'Search by code...',
            clearSearch: 'Clear search',
            searchEmpty: 'No promo codes match your search',
            resultsCount: 'Found: {{count}} of {{total}}',
            totalCount: 'Total promo codes: {{count}}',
            backToList: 'Back to promo codes',
            settingsTitle: 'Settings',
            editStatus: 'Change status',
            confirm: {
              createTitle: 'Create promo code?',
              createSubtitle: 'Review the details before creating.',
              updateSubtitle: 'Review the changes before saving.',
              activateTitle: 'Activate promo code?',
              deactivateTitle: 'Deactivate promo code?',
              updateStartsAtTitle: 'Change start date?',
              updateExpiresAtTitle: 'Change expiry date?',
              cancel: 'Cancel',
              confirm: 'Confirm',
              notSpecified: 'Not specified'
            }
          },
          newsBanners: {
            title: 'News Banners',
            listSubtitle: 'HTML banners for customers and providers in the app',
            create: 'Create banner',
            cancelCreate: 'Hide form',
            refresh: 'Refresh list',
            submit: 'Create banner',
            submitting: 'Saving...',
            saveChanges: 'Save changes',
            deleting: 'Deleting...',
            createSuccess: 'Banner created successfully.',
            createError: 'Failed to create banner',
            updateError: 'Failed to update banner',
            deleteError: 'Failed to delete banner',
            loadError: 'Failed to load banners',
            empty: 'No banners yet',
            noText: 'No text',
            htmlContent: 'HTML content',
            htmlPlaceholder: '<div style="padding:16px">Your banner text</div>',
            preview: 'Preview',
            previewEmpty: 'Banner preview will appear here',
            zoom: {
              open: 'Open enlarged view',
              in: 'Zoom in',
              out: 'Zoom out',
              reset: 'Reset zoom',
              close: 'Close'
            },
            startsAt: 'Show from',
            expiresAt: 'Show until',
            registeredFrom: 'Registered from',
            registeredTo: 'Registered to',
            registeredHint: 'Only new users who registered within this period will see the banner.',
            edit: 'Edit',
            delete: 'Delete',
            editTitle: 'Edit banner',
            editNote: 'HTML content cannot be changed — update the schedule and audience.',
            statusLive: 'Live',
            statusIdle: 'Not shown',
            totalCount: 'Total banners: {{count}}',
            audienceLabel: 'Audience',
            audience: {
              all: 'All roles',
              customer: 'Customers',
              provider: 'Providers',
              users: 'By ID list',
              usersCount: '{{count}} users'
            },
            userIdsPlaceholder: 'UUIDs separated by comma or newline',
            userIdsHint: 'When a list is provided, only these users see the banner (role is ignored).',
            errorHtml: 'Please provide the banner HTML content',
            errorDateOrder: 'End date must be later than start date',
            errorRegisteredDateOrder: '"To" date must be later than "from" date',
            errorUsersRequired: 'Provide at least one user ID',
            errorUsersInvalid: 'Invalid ID format: {{ids}}',
            confirm: {
              deleteTitle: 'Delete banner?',
              deleteSubtitle: 'This action is irreversible. The banner will no longer be shown to users.',
              cancel: 'Cancel',
              delete: 'Delete',
              notSpecified: 'Not specified'
            }
          },
          publicFiles: {
            title: 'Public Files',
            listSubtitle: 'Public files for marketplace service icons and other needs',
            upload: 'Upload file',
            cancelUpload: 'Hide form',
            refresh: 'Refresh list',
            submit: 'Upload',
            submitting: 'Uploading...',
            uploadSuccess: 'File uploaded successfully.',
            uploadError: 'Failed to upload file',
            loadError: 'Failed to load public files',
            empty: 'No files yet',
            file: 'File',
            fileHint: 'A publicly accessible image (e.g. a marketplace service icon).',
            preview: 'Preview',
            url: 'URL',
            totalCount: 'Total files: {{count}}',
            errorFileRequired: 'Please select a file to upload',
            delete: 'Delete',
            deleting: 'Deleting...',
            deleteError: 'Failed to delete file',
            confirm: {
              deleteTitle: 'Delete file?',
              deleteSubtitle: 'The file will be permanently removed from storage. If it is used anywhere (e.g. as a service icon), the link will stop working.',
              cancel: 'Cancel',
              delete: 'Delete'
            }
          },
          deleteUser: {
            title: 'Delete user',
            subtitle: 'Find a user and permanently delete their account',
            warning: 'This is a hard delete: the profile and all related data will be erased forever. Make sure you picked the right user.',
            searchPlaceholder: 'Name, phone or user ID',
            clear: 'Clear',
            hintName: 'Name',
            hintPhone: 'Phone',
            hintId: 'Profile UUID',
            emptyTitle: 'Start searching',
            emptyText: 'Enter a name, phone number or ID to find the user to delete.',
            noResults: 'No users found',
            noResultsText: 'Check your query — try the full phone number or UUID.',
            noName: 'No name',
            found: 'Showing {{shown}} of {{total}}',
            refineHint: 'Not all matches are shown — refine your query.',
            searchError: 'Search failed',
            delete: 'Delete',
            deleting: 'Deleting...',
            deleteError: 'Failed to delete user',
            deleteSuccess: 'User “{{name}}” deleted',
            confirm: {
              title: 'Delete user permanently?',
              subtitle: 'This action cannot be undone. Make sure you are deleting the right account.',
              consequenceProfile: 'The profile and account access will be removed',
              consequenceData: 'Related user data will be erased',
              consequenceIrreversible: 'The account cannot be restored',
              acknowledge: 'I understand that deletion is irreversible',
              cancel: 'Cancel',
              delete: 'Delete forever'
            }
          },
          marketplace: {
            title: 'Marketplace',
            subtitle: 'Marketplace services for customers and purchase statistics',
            priceValue: '{{price}} MDL',
            tabs: {
              services: 'Services',
              purchases: 'Purchases'
            },
            purchaseStatuses: {
              OPEN: 'Open',
              IN_PROGRESS: 'In progress',
              CLOSED: 'Closed'
            },
            services: {
              icon: 'Icon',
              iconPlaceholder: '🧰 or https://...',
              iconHint: 'Emoji, text, or an image URL',
              serviceTitle: 'Title',
              serviceTitleLang: 'Title ({{lang}})',
              titlePlaceholder: 'Service title',
              description: 'Description',
              descriptionLang: 'Description ({{lang}})',
              descriptionPlaceholder: 'Short service description',
              languages: {
                ro: 'Romanian',
                ru: 'Russian',
                en: 'English'
              },
              langHint: 'The title is required in all three languages, the description is optional',
              price: 'Price',
              pricePlaceholder: '100',
              createdAt: 'Created',
              create: 'Create service',
              cancelCreate: 'Hide form',
              refresh: 'Refresh list',
              submit: 'Create',
              submitting: 'Saving...',
              saveChanges: 'Save changes',
              deleting: 'Deleting...',
              edit: 'Edit',
              delete: 'Delete',
              editTitle: 'Edit service',
              createSuccess: 'Service created successfully.',
              createError: 'Failed to create service',
              updateError: 'Failed to update service',
              deleteError: 'Failed to delete service',
              loadError: 'Failed to load services',
              empty: 'No services yet',
              noDescription: 'No description',
              totalCount: 'Total services: {{count}}',
              errorIcon: 'Please provide the service icon',
              errorTitle: 'Please provide the service title',
              errorTitleLang: 'Please provide the service title in {{lang}}',
              errorPrice: 'Enter a valid price (a whole number greater than 0)'
            },
            purchases: {
              refresh: 'Refresh',
              loadError: 'Failed to load purchases',
              empty: 'No purchases yet',
              totalLabel: 'Total purchases',
              totalCount: 'Total purchases: {{count}}',
              sort: 'Sorting',
              sortByDate: 'By date',
              sortByPrice: 'By price',
              sortByStatus: 'By status',
              user: 'User',
              service: 'Service',
              price: 'Price',
              status: 'Status',
              createdAt: 'Purchase date',
              changeStatus: 'Change status',
              newStatus: 'New status',
              saveStatus: 'Save status',
              statusError: 'Failed to change purchase status'
            },
            confirm: {
              cancel: 'Cancel',
              delete: 'Delete',
              deleteTitle: 'Delete service?',
              deleteSubtitle: 'This action is irreversible. The service will disappear from the marketplace.'
            }
          },
          transactions: {
            title: 'Transactions',
            refresh: 'Refresh',
            totalCount: 'Total transactions: {{count}}',
            loadError: 'Failed to load transactions',
            empty: 'No transactions yet',
            amountValue: '{{amount}} MDL',
            filters: {
              userProfileId: 'User ID',
              userProfileIdPlaceholder: 'User UUID',
              orderId: 'Order ID',
              orderIdPlaceholder: 'Order UUID',
              type: 'Transaction type',
              allTypes: 'All types',
              typesSelected: 'Types selected: {{count}}',
              createdFrom: 'Date from',
              createdTo: 'Date to'
            },
            summary: {
              totalCredit: 'Credits',
              totalDebit: 'Debits',
              net: 'Net',
              byType: 'By transaction type'
            },
            table: {
              type: 'Type',
              amount: 'Amount',
              balanceAfter: 'Balance after',
              userProfileId: 'User',
              orderId: 'Order',
              createdAt: 'Date',
              openUser: 'Open user profile',
              openOrder: 'Open order'
            },
            types: {
              TOPUP_MODERATOR: 'Moderator top-up',
              TOPUP_PACKAGE_PURCHASE: 'Package purchase',
              TOPUP_PACKAGE_PURCHASE_MIA: 'Package purchase (MIA)',
              FIRST_PACKAGE_BONUS: 'First package bonus',
              REFERRAL_BONUS: 'Referral bonus',
              WITHDRAWAL_MODERATOR: 'Moderator withdrawal',
              ORDER_PARTICIPATION: 'Order participation',
              ORDER_PAYMENT: 'Order payment'
            }
          },
          notifications: {
            badge: 'Notifications',
            title: 'Send Push Notifications',
            subtitle: 'Send push notifications: to all users, by filters, or by ID.',
            heroTitle: 'Push Notifications',
            heroSubtitle: 'App message: text, audience, and screen.',
            formLabel: 'Push Notification',
            formTitle: 'Compose and Send',
            sectionContent: 'Message & Audience',
            sectionTechnical: 'Technical Parameters',
            titleField: 'Title',
            titlePlaceholder: 'Notification title',
            description: 'Description',
            descriptionPlaceholder: 'Message text',
            imageUrl: 'Image URL (optional)',
            language: 'Language',
            targetType: 'To whom',
            targetAll: 'All users',
            targetUsers: 'Specific users (by ID)',
            targetFilters: 'By filters (roles / platform)',
            byFilters: 'By filters',
            byId: 'By ID',
            profileIds: 'Profile IDs (comma separated)',
            targetRole: 'Recipient Role',
            recipient: {
              customer: 'Customer',
              provider: 'Master'
            },
            screen: 'Screen on open',
            mediaAndLocale: 'Media & Localization',
            languageRu: 'Russian',
            languageRo: 'Română',
            languageEn: 'English',
            platform: 'Platform',
            send: 'Send',
            sending: 'Sending...',
            sent: 'Notification sent successfully!',
            sendError: 'Error sending notification',
            sendResultStats: 'Total: {{total}} · delivered: {{success}} · failed: {{failure}}',
            mediaSection: 'Media',
            localeTabsLabel: 'Notification text language',
            languages: {
              ru: 'Russian',
              ro: 'Romanian',
              en: 'English'
            },
            failedTitle: 'Not delivered ({{count}}):',
            copyIds: 'Copy',
            copied: 'Copied',
            screens: {
              clientPending: 'Pending Services',
              clientActive: 'Active Services',
              clientCompleted: 'Completed Services',
              clientNewRequest: 'New Request',
              clientNotifications: 'Notifications',
              clientProfile: 'Profile',
              clientSettings: 'Settings',
              masterPurchased: 'Purchased Services',
              masterActive: 'Active Services',
              masterCompleted: 'Completed Services',
              masterMarketplace: 'Marketplace',
              masterWallet: 'Wallet',
              masterCards: 'My Cards',
              masterProfile: 'My Profile',
              masterPortfolio: 'Portfolio',
              masterReviews: 'Reviews'
            },
            profileIdsPlaceholder: 'UUID, UUID...',
            imageUrlPlaceholder: 'https://...',
            saveToHistory: 'Save notification to history',
            saveToUserLabel: 'Save in user app',
            saveToDbLabel: 'Save to database',
            confirm: {
              title: 'Confirm send',
              subtitle: 'Review the message, filters, and recipients before sending.',
              send: 'Send',
              sectionMessage: 'Notification text',
              sectionParams: 'Delivery settings',
              badgeFilters: 'By filters',
              badgeById: 'By ID',
              idsShowAll: 'Show all',
              idsShowLess: 'Show less'
            },
            validation: {
              titleRequired: 'Enter a title',
              descriptionRequired: 'Enter the message text',
              profileIdsRequired: 'Enter at least one profile ID',
              platformRequired: 'Select at least one platform (Android or iOS)'
            },
            schedule: {
              sectionTitle: 'Scheduling',
              toggleNow: 'Send now',
              toggleLater: 'Schedule',
              submit: 'Schedule',
              date: 'Date',
              time: 'Time',
              add: 'Add',
              removeSlot: 'Remove time',
              pickDateTime: 'Pick a date and time',
              pastError: 'Cannot schedule in the past',
              duplicate: 'This time is already added',
              noSlots: 'Add at least one send time',
              tzHint: 'Times are in Chișinău time (Europe/Chisinau)',
              scheduledOk: 'Notification scheduled ({{count}})'
            },
            scheduledList: {
              title: 'Scheduled notifications',
              refresh: 'Refresh',
              loading: 'Loading...',
              empty: 'No scheduled notifications',
              request: 'Request data',
              cancel: 'Cancel',
              cancelling: 'Cancelling...',
              cancelConfirm: 'Cancel this scheduled notification?',
              cancelled: 'Notification cancelled',
              loadError: 'Failed to load the list',
              cancelError: 'Failed to cancel the notification'
            }
          }
        },
        login: {
          title: 'System Login',
          phone: 'Phone number',
          password: 'Password',
          role: 'Role',
          selectRole: 'Select role',
          submit: 'Login',
          phonePlaceholder: '12345678',
          remember: 'Remember me',
          showPassword: 'Show password',
          hidePassword: 'Hide password'
        },
        home: {
          title: 'Home',
          subtitle: 'Welcome to the support agent panel!',
          logs: {
            title: 'System Logs',
            subtitle: 'Total records: {{count}}',
            loading: 'Loading logs...',
            emptyTitle: 'No logs found',
            emptyText: 'No matching system actions recorded.',
            expand: 'Expand',
            collapse: 'Collapse',
            reason: 'Reason',
            actor: 'Actor',
            target: 'Target',
            payload: 'Payload',
            filters: {
              actionContainsPlaceholder: 'Search by action...',
              targetId: 'Target ID',
              actorId: 'Actor ID',
              targetIdPlaceholder: 'Enter target ID...',
              actorIdPlaceholder: 'Enter actor ID...',
              from: 'Date from',
              to: 'Date to',
              sortByCreatedDate: 'Creation date'
            }
          },
          tabs: {
            system: 'System Logs',
            orders: 'Order Logs',
            transactions: 'Transactions'
          },
          orderLogs: {
            title: 'Order Moderation Logs',
            subtitle: 'Total records: {{count}}',
            loading: 'Loading order logs...',
            emptyTitle: 'No order logs found',
            emptyText: 'No order moderation records yet.',
            untitled: 'Untitled',
            statusOk: 'OK',
            statusError: 'Error',
            attempts: 'Attempts: {{count}}',
            description: 'Description',
            aiError: 'AI error',
            user: 'User',
            createdAt: 'Created',
            updatedAt: 'Updated',
            exportCsv: 'Export CSV',
            exportAll: 'Export all (CSV)',
            exporting: 'Exporting...',
            csvExportEmpty: 'No logs on the current page to export',
            csvExportError: 'Failed to export logs',
            filters: {
              sortByCreatedDate: 'Creation date',
              sortByUpdatedDate: 'Update date',
              sortByAttempts: 'Attempts count',
              userId: 'User ID',
              userIdPlaceholder: 'Enter user ID...'
            }
          }
        },
        orders: {
          title: 'Orders',
          loading: 'Loading orders...',
          purchased: 'purchased',
          filters: {
            name: 'Name',
            namePlaceholder: 'Enter order name',
            allStatuses: 'All statuses',
            sortButton: 'Sort',
            sortBy: 'Sort by',
            sortByDate: 'Update date',
            sortByCreatedDate: 'Creation date',
            id: 'Order ID',
            idPlaceholder: 'Enter ID...',
            sortDirection: 'Direction',
            descending: 'Descending',
            ascending: 'Ascending',
            extraFilters: 'Extra filters',
            allLanguages: 'All languages',
            languageRu: 'Russian',
            languageEn: 'English',
            languageRo: 'Romanian',
            neverBought: 'Not bought',
            allPurchaseStatuses: 'All orders',
            dateFrom: 'Date from',
            dateTo: 'Date to',
            statusDatesTitle: 'Status change date',
            statusDates: {
              IN_WORK: 'In work',
              DONE: 'Done',
              CANCELED: 'Canceled'
            }
          },
          statusLabels: {
            IN_PROGRESS: 'in progress',
            IN_WORK: 'In work',
            DONE: 'Completed',
            DONE_DELETED: 'Completed (deleted by client)',
            CANCELED: 'Canceled',
            BLOCKED: 'blocked',
            UNKNOWN: 'Unknown'
          },
          empty: {
            title: 'No orders found',
            subtitle: 'Try adjusting your filters'
          },
          exportCsv: 'Export CSV',
          exportAll: 'Export all (CSV)',
          exporting: 'Exporting...',
          csvExportEmpty: 'No orders on the current page to export'
        },
        users: {
          title: 'Users',
          loading: 'Loading users...',
          filters: {
            allRoles: 'All roles',
            allStatuses: 'All statuses',
            namePlaceholder: 'Enter name...',
            phone: 'Phone',
            phonePlaceholder: 'Enter number...',
            role: 'Role',
            status: 'Status',
            verification: 'Verification',
            allVerification: 'Any verification',
            verifiedOnly: 'Verified only',
            notVerifiedOnly: 'Not verified only',
            marketingConsent: 'Marketing consent',
            allMarketingConsent: 'Any consent',
            marketingConsentYes: 'Opted in to mailing',
            marketingConsentNo: 'No consent',
            dateFrom: 'Date from',
            dateTo: 'Date to',
            ratingFrom: 'Rating from',
            ratingTo: 'Rating to',
            ratingRangeShortFrom: 'From',
            ratingRangeShortTo: 'To',
            ordersCount: 'Orders count',
            ordersCountPlaceholder: 'e.g. 5',
            ordersCountOrMore: 'or more',
            sortButton: 'Sort',
            sortBy: 'Sort by',
            id: 'User ID',
            idPlaceholder: 'Enter ID...',
            sortByFullName: 'By name',
            sortByRating: 'By rating',
            sortByDate: 'Update date',
            sortByCreatedDate: 'Creation date',
            descending: 'Descending',
            ascending: 'Ascending',
            sortDirection: 'Direction',
            providerCategories: 'Provider categories',
            providerCategoriesHint: 'Shows providers who have at least one of the selected categories.',
            categoriesSearchPlaceholder: 'Search categories by name...',
            categoriesLoading: 'Loading categories...',
            categoriesEmpty: 'No categories match your search',
            categoriesError: 'Could not load categories',
            categoriesClearSelected: 'Clear categories',
            categoriesRemoveChip: 'Remove category',
            regions: 'Company regions',
            regionsHint: 'You can select multiple regions — only users with companies in these regions will remain.',
            regionsSearchPlaceholder: 'Search region by name...',
            regionsLoading: 'Loading regions...',
            regionsEmpty: 'No regions found',
            regionsError: 'Could not load regions',
            regionsClearSelected: 'Clear regions',
            regionsRemoveChip: 'Remove region'
          },
          roles: {
            CUSTOMER: 'Customer',
            PROVIDER: 'Master',
            SUPPORT: 'Support',
            MODERATOR: 'Moderator',
            ADMIN: 'Administrator',
            DEV: 'Developer',
            CLIENT: 'Customer',
            EMPLOYEE: 'Employee'
          },
          statuses: {
            ACTIVE: 'Active',
            INACTIVE: 'Inactive',
            BLOCKED: 'Blocked'
          },
          plans: {
            BASIC: 'Basic',
            PREMIUM: 'Premium',
            PRO: 'Pro',
            basic: 'Basic'
          },
          labels: {
            reviews: 'reviews',
            orders: 'orders',
            notProvided: 'Not provided',
            verified: 'Verified',
            notVerified: 'Not verified'
          },
          empty: {
            title: 'No users found',
            subtitle: 'Try adjusting your filters'
          },
          exportCsv: 'Export CSV',
          exportAll: 'Export all (CSV)',
          exporting: 'Exporting...',
          csvExportEmpty: 'No users on the current page to export',
          adminExportCsv: 'Admin export (CSV)',
          adminExportAllCsv: 'Admin export all (CSV)',
          adminExporting: 'Exporting...',
          actions: {
            button: 'Actions',
            generateReport: 'Generate report',
            generateReportHint: 'All fields, including orders and payments',
            exportData: 'Export data',
            exportDataHint: 'ID, name and phone as CSV',
            adminBadge: 'Admin',
            back: 'Back',
            audienceTitle: 'Who to export?',
            audienceAll: 'All users',
            audienceAllHint: 'Matching the current search filters',
            audienceMarketing: 'Mailing list only',
            audienceMarketingHint: 'Current filters + marketing consent',
            preparing: 'Preparing file...',
            empty: 'No users to export',
            failed: 'Failed to export users'
          }
        },
        complaints: {
          title: 'Complaints',
          loading: 'Loading complaints...',
          filters: {
            allStatuses: 'All statuses'
          },
          empty: {
            title: 'No complaints found',
            subtitle: 'Nothing was found for your request.'
          },
          statuses: {
            PENDING: 'Pending',
            IN_REVIEW: 'In Review',
            RESOLVED: 'Resolved',
            REJECTED: 'Rejected'
          },
          targetTypes: {
            USER: 'User',
            COMMENT: 'Comment',
            ORDER: 'Order'
          },
          filters: {
            allTypes: 'All types',
            searchPlaceholder: 'Search by ID or description...'
          },
          labels: {
            reporterId: 'Reporter'
          }
        },
        orderDetails: {
          title: 'Request',
          loading: 'Loading...',
          error: 'Error loading order',
          notFound: 'Order not found',
          missing: 'Order with ID {{id}} not found',
          status: {
            inWork: 'In work'
          },
          sections: {
            main: 'Main Information',
            customer: 'Customer',
            companiesLabel: 'Companies',
            executingCompany: 'Executing Company'
          },
          fields: {
            category: 'Category',
            description: 'Description',
            price: 'Price',
            tags: 'Tags:'
          },
          address: {
            title: 'Order Address'
          },
          timeline: {
            title: 'Timeline',
            startDate: 'Start Date',
            createdAt: 'Created At',
            updatedAt: 'Updated At'
          },
          photos: {
            title: 'Order Photos'
          },
          companies: {
            empty: 'No companies found'
          },
          changeStatus: 'Change Status',
          selectStatusPlaceholder: 'Select status',
          confirmStatusChange: 'Change order status to "{{status}}"?',
          tabs: {
            main: 'Main information',
            interaction: 'Interaction'
          },
          summary: {
            title: 'Order summary'
          },
          interaction: {
            statusTitle: 'Order status',
            masterLabel: 'Company assigned to the order',
            masterPlaceholder: 'Select company',
            masterRequired: 'Select a company before changing the status',
            noteTitle: 'Support notes for this order',
            notePlaceholder: 'Add an internal note for the support team about this order...',
            clear: 'Clear',
            save: 'Save',
            deleteConfirm: 'Delete this note?'
          }
        },
        complaintDetails: {
          title: 'Complaint #{{id}}',
          error: 'Error loading complaint',
          notFound: 'Complaint not found',
          changeStatus: 'Change Status',
          selectStatusPlaceholder: 'Select status',
          mainInfo: 'Main Information',
          description: 'Complaint Description',
          reviewTitle: 'Comment',
          reviewError: 'Error loading review',
          metadata: 'Metadata',
          labels: {
            type: 'TARGET TYPE',
            reporterId: 'REPORTER ID',
            targetId: 'TARGET ID',
            createdAt: 'CREATED AT',
            updatedAt: 'UPDATED AT'
          },
          reviewButtons: {
            viewReviewer: 'View Reviewer',
            viewReviewed: 'View Reviewed'
          }
        },
        userDetails: {
          title: 'User Profile',
          loading: 'Loading...',
          edit: 'Edit',
          editUser: 'Edit User',
          contact: 'Contacts',
          personal: 'Personal Data',
          business: 'Business',
          system: 'System Info',
          tabs: {
            profile: 'Profile',
            reviews: 'Reviews ({{count}})',
            orders: 'Purchased Orders',
            clientOrders: 'Orders ({{count}})',
            interaction: 'Interaction'
          },
          statusActions: {
            change: 'Change',
            changeTitle: 'Change Status',
            blockAction: 'Block',
            blockQuestion: 'Block user {{name}}?',
            unblockAction: 'Unblock',
            unblockQuestion: 'Unblock user {{name}}?',
            deactivateAction: 'Deactivate',
            statusChangeQuestion: 'Change status of user {{name}} to "{{status}}"?'
          },
          labels: {
            fullName: 'Full Name',
            role: 'Role',
            verified: 'Verification',
            balance: 'Balance',
            marketplaceBalance: 'Marketplace Balance',
            inDebt: 'In debt',
            phone: 'Phone',
            email: 'Email',
            address: 'Address',
            dateOfBirth: 'Date of Birth',
            gender: 'Gender',
            language: 'Language',
            company: 'Company',
            companyRating: 'Company Rating',
            referralCode: 'Ref. Code',
            referrals: 'Referrals',
            referralsPeriod: 'For period',
            userId: 'User ID',
            created: 'Created',
            updated: 'Updated',
            debtStartedAt: 'Debt since',
            marketingConsent: 'Mailing',
            marketingConsentAt: 'Consent date',
            marketingAgreed: 'Opted in',
            marketingDeclined: 'Declined',
            marketingNoAnswer: 'No answer'
          },
          balance: {
            edit: 'Edit Balance',
            title: 'Balance Adjustment',
            currentBalance: 'Current Balance',
            actionType: 'Operation Type',
            add: 'Add',
            subtract: 'Subtract',
            subtracting: 'Subtraction',
            adding: 'Deduction',
            amount: 'Amount',
            reason: 'Reason',
            reasonPlaceholder: 'Specify the reason for balance change...',
            current: 'Current',
            resulting: 'Resulting',
            confirm: 'Confirm',
            confirmTitle: 'Confirmation',
            opType: 'Operation',
            success: 'Balance adjusted successfully',
            error: 'Error adjusting balance',
            debtJustNow: 'just now',
            errors: {
              amountInvalid: 'Amount must be at least 1',
              amountTooLarge: 'Amount cannot exceed {{max}} MDL',
              balanceExceedsMax: 'Balance will exceed {{max}} MDL',
              insufficientBalance: 'Insufficient funds on balance',
              reasonRequired: 'Reason is required'
            }
          },
          company: {
            title: 'Portfolio',
            loading: 'Loading data...',
            name: 'Name',
            rating: 'Rating',
            languages: 'Languages',
            openToUrgent: 'Urgent Orders',
            minimumCallOutPrice: 'Min. callout',
            workInfo: 'Work',
            teamSize: 'Team size',
            team: 'Works with team',
            schedule: 'Schedule',
            about: 'About',
            description: 'Description',
            bio: 'Bio',
            categories: 'Categories',
            regions: 'Regions',
            services: 'Services',
            documents: 'Documents',
            photos: 'Photos',
            categoryFallback: 'Category {{index}}',
            serviceFallback: 'Service {{index}}',
            documentFallback: 'Document {{index}}',
            photoFallback: 'Photo {{index}}'
          },
          modal: {
            cancel: 'Cancel',
            save: 'Save',
            editUserTitle: 'Edit User',
            status: 'Status',
            plan: 'Plan',
            selectGender: 'Select gender',
            selectLanguage: 'Select language',
            selectPlan: 'Select plan',
            male: 'Male',
            female: 'Female',
            fullNamePlaceholder: 'Enter full name',
            emailPlaceholder: 'Enter email',
            referralCodePlaceholder: 'Enter referral code'
          },
          messages: {
            copied: 'Copied!',
            userUpdated: 'User data updated',
            userUpdateError: 'Error updating user',
            statusUpdateError: 'Error updating status',
            noteSaved: 'Note saved',
            reviewSaved: 'Review published'
          },
          reviews: {
            title: 'Reviews',
            refresh: 'Refresh',
            deleteConfirm: 'Delete this review?',
            deleteSuccess: 'Review deleted',
            deleteError: 'Error deleting review',
            loadError: 'Error loading reviews',
            emptyTitle: 'No reviews yet',
            emptyText: 'This user has no reviews yet',
            noRating: 'No rating',
            noComment: 'No comment',
            viewProfile: 'Profile',
            deleting: 'Deleting...',
            delete: 'Delete'
          },
          orders: {
            title: 'Purchased Orders',
            clientTitle: 'Client Orders',
            sortBy: 'Sort by',
            sortByCreated: 'Date created',
            sortByUpdated: 'Date updated',
            sortDesc: 'Descending',
            sortAsc: 'Ascending',
            loading: 'Loading orders...',
            loadError: 'Error loading orders',
            view: 'View',
            emptyTitle: 'No purchased orders',
            emptyText: 'This provider has no purchased orders yet',
            clientEmptyTitle: 'No orders yet',
            clientEmptyText: 'This user has no orders yet',
            table: {
              id: 'Order ID',
              title: 'Title',
              status: 'Status',
              accepted: 'Accepted',
              createdAt: 'Created',
              updatedAt: 'Updated',
              actions: 'Actions'
            }
          },
          schedule: {
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday',
            dayOff: 'Day off',
            flexible: 'Flexible schedule',
            notConfigured: 'Schedule not configured'
          },
          verification: {
            title: 'Company Verification',
            verified: 'Company is verified',
            notVerified: 'Company is not verified',
            verifyAction: 'Verify company',
            unverifyAction: 'Remove verification',
            successVerified: 'Company verified',
            successUnverified: 'Company verification removed',
            error: 'Verification update error: {{error}}'
          },
          interaction: {
            statusTitle: 'User Status',
            statusSub: 'Control the user access to the platform',
            noteTitle: 'Support Notes',
            noteSub: 'Internal notes are visible only to the team',
            notePlaceholder: 'Add a note about user interaction...',
            clear: 'Clear',
            save: 'Save',
            deleteConfirm: 'Delete this note?',
            review: {
              title: 'Leave a review for the master',
              subtitle: 'Publish an official review on behalf of the selected account',
              ratingLabel: 'Rating',
              reviewerLabel: 'ID of the account leaving the review',
              commentLabel: 'Comment',
              commentPlaceholder: 'Describe the quality of the master\'s work...',
              submit: 'Publish review',
              invalidReviewer: 'Enter a valid account ID (UUID)'
            }
          }
        }
      }
    },
    ro: {
      translation: {
        homepage: {
          badge: 'Spațiul de lucru al suportului TeSalut',
          greeting: {
            morning: 'Bună dimineața',
            day: 'Bună ziua',
            evening: 'Bună seara',
            night: 'Noapte bună'
          },
          titleLead: 'Suportul TeSalut\u00A0—',
          titleAccent: 'rapid și într-un singur loc',
          lead: 'Comenzile, utilizatorii, reclamațiile și logurile sunt mereu la îndemână. Rezolvați solicitările, gestionați profilurile clienților și prestatorilor și păstrați legătura cu echipa fără a schimba aplicațiile.',
          ctaPrimary: 'Mergi la comenzi',
          ctaSecondary: 'Caută un utilizator',
          role: 'Rolul tău',
          stats: {
            users: 'Utilizatori',
            usersHint: 'Total în sistem',
            newUsers: 'Noi azi',
            newUsersHint: 'Înregistrați de la miezul nopții',
            orders: 'Comenzi',
            ordersHint: 'Din toate timpurile',
            complaints: 'Reclamații deschise',
            complaintsHint: 'Așteaptă examinare',
            unavailable: 'Fără date'
          },
          sections: {
            badge: 'Secțiuni',
            title: 'Cu ce începem azi?',
            subtitle: 'Aici apar doar secțiunile disponibile rolului tău.',
            open: 'Deschide',
            orders: 'Căutare comenzi, statusuri, participanți și istoricul modificărilor.',
            users: 'Profilurile clienților și prestatorilor: sold, recenzii, comentarii de suport.',
            complaints: 'Examinarea reclamațiilor despre utilizatori, comenzi și comentarii.',
            chat: 'Mesagerie în echipă: chaturi private, grupuri, fișiere și mesaje vocale.',
            calendar: 'Programul echipei: ture, lansări și întâlniri.',
            logs: 'Loguri de sistem și jurnalul de moderare a comenzilor.',
            statistics: 'Grafice pentru utilizatori, comenzi și recenzii pe orice perioadă.',
            admin: 'Coduri promo, notificări, marketplace, bannere și angajați.'
          },
          tips: {
            badge: 'Sfaturi',
            title: 'Lucrează mai rapid',
            subtitle: 'Câteva trucuri care economisesc timp în munca de zi cu zi.',
            searchTitle: 'Căutare după ID',
            searchText: 'Lipește un UUID complet în filtru și profilul se deschide imediat, fără a răsfoi pagini.',
            exportTitle: 'Export pentru newsletter',
            exportText: 'Meniul „Acțiuni” din pagina utilizatorilor exportă doar pe cei care au acceptat newsletterul.',
            themeTitle: 'Temă deschisă și întunecată',
            themeText: 'Comutatorul este în bara de sus, alegerea se memorează.',
            languageTitle: 'Trei limbi',
            languageText: 'Русский, English și Română, limba se schimbă în bara de sus.'
          }
        },
        devNotice: {
          title: 'Pagină în dezvoltare',
          text: 'Secțiunea este încă în lucru: datele provin dintr-un set de test și pot fi afișate incorect. Nimic din ce modifici aici nu se salvează încă pe server.',
          button: 'Am înțeles'
        },
        chat: {
          title: 'Chat',
          subtitle: 'Comunicare cu utilizatorii și echipa',
          connection: {
            connecting: 'Se conectează la chat...',
            reconnecting: 'Se reconectează la chat...',
            failed: 'Conexiunea realtime nu este disponibilă — mesajele circulă prin cereri obișnuite',
            retry: 'Reîncearcă'
          },
          errors: {
            history: 'Istoricul mesajelor nu a putut fi încărcat',
            generic: 'Eroare de chat'
          },
          list: {
            title: 'Mesaje',
            searchPlaceholder: 'Caută în chaturi',
            empty: 'Încă nu există chaturi',
            notFound: 'Nu s-a găsit nimic',
            newChat: 'Scrie unei persoane noi',
            newGroup: 'Grup nou',
            writeToEmployee: 'Scrie unui coleg',
            createGroup: 'Creează grup',
            unpin: 'Anulează fixarea',
            unmute: 'Activează notificările'
          },
          window: {
            empty: 'Alege un chat pentru a începe conversația',
            activeNow: 'Activ acum',
            typing: 'scrie…',
            typingNamed: '{{name}} scrie…',
            members: '{{count}} participanți',
            offline: 'offline',
            offlineHint: 'Fără conexiune — mesajele circulă prin cereri obișnuite',
            actions: 'Acțiuni',
            pin: 'Fixează',
            unpin: 'Anulează fixarea',
            mute: 'Dezactivează notificările',
            unmute: 'Activează notificările',
            rename: 'Redenumește grupul',
            save: 'Salvează',
            participants: 'Participanții grupului'
          },
          composer: {
            placeholder: 'Scrie un mesaj...',
            placeholderNamed: 'Mesaj pentru {{name}}...',
            attach: 'Atașează un fișier',
            emoji: 'Emoji',
            voice: 'Înregistrează un mesaj vocal',
            send: 'Trimite',
            cancelReply: 'Anulează răspunsul',
            uploadError: 'Fișierul nu a putut fi încărcat',
            voiceError: 'Mesajul vocal nu a putut fi trimis',
            recordCancel: 'Anulează',
            recordSend: 'Trimite mesajul vocal'
          },
          message: {
            reply: 'Răspunde',
            react: 'Reacție',
            image: 'Imagine'
          },
          preview: {
            photo: 'Fotografie',
            voice: 'Mesaj vocal',
            file: 'Fișier'
          },
          system: {
            memberAdded: '{{author}} l-a adăugat pe {{member}}',
            memberRemoved: '{{author}} l-a eliminat pe {{member}}',
            memberLeft: '{{member}} a părăsit grupul',
            titleChanged: '{{author}} a redenumit grupul în „{{title}}”',
            unknown: 'Participant'
          },
          date: {
            today: 'Astăzi',
            yesterday: 'Ieri'
          },
          fallback: {
            group: 'Grup',
            order: 'Comanda {{id}}',
            user: 'Utilizatorul {{id}}',
            chat: 'Chat'
          },
          participants: {
            title: 'Participanți',
            count: '{{count}} persoane',
            add: 'Adaugă participanți',
            remove: 'Elimină din grup',
            you: 'tu',
            leave: 'Părăsește grupul',
            leaveConfirm: 'Părăsești grupul?',
            leaveCancel: 'Anulează',
            leaveAction: 'Ieși',
            leaving: 'Se iese...',
            removeError: 'Participantul nu a putut fi eliminat',
            leaveError: 'Nu s-a putut părăsi grupul',
            roles: {
              OWNER: 'Proprietar',
              ADMIN: 'Admin'
            }
          },
          picker: {
            directTitle: 'Chat nou',
            directSub: 'Caută un coleg după nume',
            groupTitle: 'Grup nou',
            groupSub: 'Denumire și participanți',
            addTitle: 'Adaugă participanți',
            addSub: 'Cei care sunt deja în grup sunt ascunși',
            namePlaceholder: 'Denumirea grupului',
            searchPlaceholder: 'Introdu numele...',
            allRoles: 'Toate rolurile',
            notFound: 'Nu am găsit pe nimeni',
            selected: 'Selectate: {{count}}',
            selectedMin: 'Selectate: {{count}}, minim {{min}}',
            create: 'Creează grupul',
            add: 'Adaugă',
            saving: 'Se salvează...',
            loadError: 'Lista angajaților nu a putut fi încărcată',
            actionError: 'Acțiunea nu a putut fi finalizată',
            openChatError: 'Chatul cu acest utilizator nu a putut fi deschis',
            roles: {
              SUPPORT: 'Suport',
              MODERATOR: 'Moderator',
              ADMIN: 'Admin',
              DEV: 'Dezvoltator'
            }
          }
        },
        calendar: {
          title: 'Calendar',
          subtitle: 'Programul echipei și evenimentele din admin',
          newEvent: 'Eveniment nou',
          newCalendar: 'Calendar nou',
          today: 'Astăzi',
          prev: 'Înapoi',
          next: 'Înainte',
          searchPlaceholder: 'Caută evenimente...',
          views: {
            month: 'Lună',
            list: 'Listă'
          },
          more: 'încă {{count}}',
          agendaEmpty: 'Niciun eveniment',
          dialog: {
            createTitle: 'Eveniment nou',
            createSub: 'Adaugă un eveniment în calendar',
            editTitle: 'Eveniment',
            editSub: 'Modifică evenimentul din calendar',
            name: 'Denumire',
            namePlaceholder: 'Introdu denumirea evenimentului...',
            calendar: 'Calendar',
            date: 'Data',
            time: 'Ora',
            duration: 'Durata',
            options: 'Opțiuni',
            allDay: 'Toată ziua',
            reminder: 'Memento',
            location: 'Loc',
            locationPlaceholder: 'Sală de ședințe, link de apel...',
            attendees: 'Participanți',
            attendeePlaceholder: 'Adaugă un participant...',
            add: 'Adaugă',
            description: 'Descriere',
            descriptionPlaceholder: 'Adaugă o descriere...',
            create: 'Creează evenimentul',
            save: 'Salvează',
            cancel: 'Anulează',
            delete: 'Șterge',
            close: 'Închide',
            durations: {
              '15': '15 min',
              '30': '30 min',
              '45': '45 min',
              '60': '1 oră',
              '90': '1,5 ore',
              '120': '2 ore',
              '180': '3 ore',
              '1440': 'Toată ziua'
            }
          }
        },
        statistics: {
          title: 'Statistici',
          subtitle: 'Indicatorii serviciului și metricile cheie în timp real',
          newReport: 'Raport nou',
          actions: 'Acțiuni',
          export: 'Export',
          sales: {
            title: 'Dinamica vânzărilor',
            subtitle: 'Vânzări lunare față de plan',
            sales: 'Vânzări',
            target: 'Plan'
          },
          revenue: {
            title: 'Structura veniturilor',
            subtitle: 'Distribuția pe surse'
          },
          transactions: {
            title: 'Ultimele tranzacții',
            subtitle: 'Operațiuni recente ale clienților',
            viewAll: 'Toate operațiunile'
          },
          products: {
            title: 'Top servicii',
            subtitle: 'Cele mai bune poziții din luna aceasta',
            viewAll: 'Vezi toate',
            sales: '{{count}} vânzări',
            stock: 'Stoc: {{count}}'
          },
          insights: {
            title: 'Analiza clienților',
            subtitle: 'Dinamica creșterii și demografia',
            tabs: {
              growth: 'Creștere',
              demographics: 'Demografie',
              regions: 'Regiuni'
            },
            growthTitle: 'Dinamica bazei de clienți',
            ageTitle: 'Grupe de vârstă',
            regionsTitle: 'Distribuția pe regiuni',
            keyMetrics: 'Indicatori cheie',
            series: {
              new: 'Noi',
              returning: 'Reveniți',
              churned: 'Plecați'
            }
          }
        },
        common: {
          language: 'Limbă',
          loading: 'Încărcare...',
          saved: 'Salvat!',
          notFound: 'Pagina nu a fost găsită',
          error: 'Eroare',
          back: 'Înapoi',
          backToList: 'Înapoi la listă',
          view: 'Vezi detalii',
          search: 'Căutare',
          searchLoading: 'Căutare...',
          clear: 'Șterge',
          reset: 'Resetează',
          save: 'Salvează',
          cancel: 'Anulează',
          close: 'Închide',
          yes: 'Da',
          no: 'Nu',
          page: 'Pagina {{page}}',
          total: '{{count}} în total',
          status: 'Stare',
          ms: 'ms',
          copy: 'Copiază',
          copied: 'Copiat!',
          notProvided: 'Nespecificat',
          actions: 'Acțiuni',
          description: 'Descriere',
          createdAt: 'Creat la',
          updatedAt: 'Actualizat la',
          pagination: {
            showing: 'Afișat {{from}} - {{to}} din {{total}}',
            previous: 'Înapoi',
            next: 'Înainte',
            page: 'Pagina {{page}}',
            pageOf: 'Pagina {{page}} din {{total}}',
            itemsPerPage: 'Elemente pe pagină',
            noResults: 'Fără rezultate',
            items: 'elemente'
          },
          houseShort: 'nr.',
          apartmentShort: 'ap.',
          datePicker: {
            placeholderDateTime: 'ZZ.LL.AAAA OO:MM',
            placeholderDate: 'ZZ.LL.AAAA',
            increase: 'Crește',
            decrease: 'Scade',
            clear: 'Curăță',
            hourLetter: 'o',
            minuteLetter: 'm',
            ok: 'OK',
            now: 'Acum',
            time: 'Ora',
            date: 'Data'
          },
          next: 'Înainte'
        },
        imageViewer: {
          title: 'Vizualizare imagine',
          prev: 'Anterioara',
          next: 'Următoarea',
          zoomIn: 'Mărește',
          zoomOut: 'Micșorează',
          loadError: 'Imaginea nu a putut fi încărcată',
          avatar: 'Avatarul utilizatorului',
          openAvatar: 'Deschide avatarul',
          showMore: 'Încă {{n}}',
          showLess: 'Restrânge'
        },
        nav: {
          sections: {
            workspace: 'Secțiuni',
            tools: 'Instrumente',
            admin: 'Administrare'
          },
          searchTitle: 'De ce ai nevoie?',
          searchPlaceholder: 'Caută în secțiuni...',
          openMenu: 'Deschide meniul',
          collapse: 'Restrânge meniul',
          expand: 'Extinde meniul',
          logo: 'SalutApp Admin',
          home: 'Acasă',
          logs: 'Jurnale',
          orders: 'Comenzi',
          users: 'Utilizatori',
          complaints: 'Sesizări',
          chat: 'Chat',
          statistics: 'Statistici',
          calendar: 'Calendar',
          tools: 'Instrumente',
          chatHint: 'Mesaje cu echipa',
          statisticsHint: 'Indicatorii serviciului',
          calendarHint: 'Program și evenimente',
          admin: 'Admin',
          logout: 'Ieșire',
          userFallback: 'Utilizator',
          languageSwitcher: 'Limbă',
          theme: {
            switchToDark: 'Temă întunecată',
            switchToLight: 'Temă luminoasă'
          }
        },
        footer: {
          copyright: '© {{year}} COOLCHAS COMMUNITY SRL – TeSalut. Toate drepturile rezervate'
        },
        admin: {
          badge: 'Administrator',
          title: 'Panou Admin',
          subtitle: 'Gestionează securitatea, configurația și fiabilitatea dintr-un singur loc.',
          createUser: 'Creează Angajat',
          createReport: 'Creează Raport',
          lastUpdate: 'Ultima actualizare: azi',
          access: 'Acces: complet',
          dashboard: {
            overview: 'Prezentare',
            orders: 'Comenzi',
            users: 'Utilizatori',
            comments: 'Comentarii',
            activeUsers: 'Activi',
            hide: 'Ascunde',
            createEmployee: 'Creează Angajat',
            promoCodes: 'Coduri promo',
            banners: 'Bannere',
            marketplace: 'Marketplace',
            publicFiles: 'Fișiere publice',
            deleteUser: 'Șterge utilizator',
            bannersTestingTitle: 'Funcționalitate în testare',
            bannersTestingText: 'Secțiunea de bannere este temporar indisponibilă — funcționalitatea este în curs de testare.',
            notifications: 'Notificări Push',
            stats: 'Statistici',
            kpi: {
              orders: 'Comenzi',
              users: 'Utilizatori',
              comments: 'Comentarii',
              dailyOrders: 'Comenzi zilnice',
              weeklyOrders: 'Comenzi săptămânale',
              newUsers: 'Utilizatori noi'
            },
            charts: {
              overview: 'Sumar',
              orders: 'Comenzi',
              userStats: 'Utilizatori',
              commentStats: 'Comentarii',
              weeklyOverview: 'Prezentare săptămânală',
              todayOrders: 'Comenzi astăzi',
              categoryDistribution: 'Distribuția pe categorii'
            },
            days: {
              mon: 'Lu', tue: 'Ma', wed: 'Mie', thu: 'Joi', fri: 'Vi', sat: 'Sâ', sun: 'Du'
            }
          },
          period: {
            day: 'Zi',
            week: 'Săptămână',
            month: 'Lună',
            all: 'Toate',
            dayShort: 'Z',
            weekShort: 'S',
            monthShort: 'L',
            allShort: 'T'
          },
          categoryStats: {
            label: 'Statistici',
            title: 'Categorii furnizori',
            shortTitle: 'Categorii',
            loading: 'Se încarcă…',
            error: 'Nu s-au putut încărca statisticile categoriilor',
            refresh: 'Actualizează',
            total: 'Total companii',
            noData: 'Nu există date despre categorii',
            noTitle: 'Fără titlu',
            companies: 'companii',
            chartAria: 'Ponderea categoriilor după numărul de companii',
            allCategories: 'Toate categoriile',
            donutShortCount: '{{count}} companii'
          },
          roles: {
            support: 'SUPPORT',
            supportDesc: 'Acces la comenzi și utilizatori',
            admin: 'ADMIN',
            adminDesc: 'Acces complet la toate funcțiile'
          },
          form: {
            title: 'Creează Angajat',
            newEmployee: 'Angajat Nou',
            createAccount: 'Creare Cont',
            username: 'Nume utilizator',
            name: 'Nume complet',
            namePlaceholder: 'Ion Popescu',
            email: 'Email',
            emailPlaceholder: 'ion@example.com',
            phone: 'Telefon',
            phonePlaceholder: '+373 600 000 00',
            password: 'Parolă',
            role: 'ROL',
            submit: 'Creează Angajat',
            submitting: 'Se creează...',
            clear: 'Șterge',
            show: 'Arată',
            hide: 'Ascunde',
            optional: '(opțional)',
            confirmTitle: 'Creezi angajatul?',
            confirmSubtitle: 'Verifică datele înainte de trimitere.',
            confirmCancel: 'Anulează',
            confirmSubmit: 'Creează',
            notSpecified: 'nespecificat',
            createSuccess: 'Angajat creat cu succes.',
            createError: 'Nu s-a putut crea angajatul',
            errorName: 'Introdu numele complet',
            errorPassword: 'Parola — minim 6 caractere',
            errorPhone: 'Introdu un număr de telefon valid',
            errorEmailFormat: 'Format email invalid',
            errorRoleForbidden: 'Nu ai permisiunea de a crea un angajat cu acest rol'
          },
          promoCodes: {
            title: 'Coduri promo',
            create: 'Creează cod promo',
            cancelCreate: 'Ascunde formularul',
            refresh: 'Actualizează lista',
            submit: 'Creează',
            submitting: 'Se creează...',
            createSuccess: 'Codul promo a fost creat.',
            createError: 'Nu s-a putut crea codul promo',
            loadError: 'Nu s-au putut încărca codurile promo',
            updateError: 'Nu s-a putut actualiza codul promo',
            empty: 'Nu există coduri promo',
            detailTitle: 'Detalii cod promo',
            code: 'Cod',
            codePlaceholder: 'SUMMER2026',
            type: 'Tip',
            bonusAmount: 'Bonus',
            startsAt: 'Început',
            expiresAt: 'Expirare',
            active: 'Status',
            activeYes: 'Activ',
            activeNo: 'Inactiv',
            activate: 'Activează',
            deactivate: 'Dezactivează',
            createdAt: 'Creat',
            saving: 'Se salvează...',
            errorCode: 'Introdu codul promo',
            errorBonus: 'Introdu o sumă bonus validă (≥ 0)',
            errorDate: 'Introdu data și ora',
            types: {
              REGISTRATION: 'Înregistrare',
              REFERRAL: 'Recomandare',
              MARKETING: 'Marketing',
              PARTNER: 'Partener'
            },
            statsTitle: 'Statistici',
            totalUsed: 'Total utilizări',
            activeUsersStat: 'Utilizatori activi',
            activeUsersTitle: 'Utilizatori activi',
            activeUsersEmpty: 'Nu există utilizatori activi',
            fullName: 'Nume complet',
            role: 'Rol',
            ordersCount: 'Comenzi',
            statsLoadError: 'Nu s-au putut încărca statisticile',
            listSubtitle: 'Gestionarea codurilor promo partenere',
            searchPlaceholder: 'Caută după cod...',
            clearSearch: 'Șterge căutarea',
            searchEmpty: 'Niciun cod promo nu corespunde căutării',
            resultsCount: 'Găsite: {{count}} din {{total}}',
            totalCount: 'Total coduri promo: {{count}}',
            backToList: 'Înapoi la listă',
            settingsTitle: 'Setări',
            editStatus: 'Modifică statutul',
            confirm: {
              createTitle: 'Creezi codul promo?',
              createSubtitle: 'Verifică datele înainte de creare.',
              updateSubtitle: 'Verifică modificările înainte de salvare.',
              activateTitle: 'Activezi codul promo?',
              deactivateTitle: 'Dezactivezi codul promo?',
              updateStartsAtTitle: 'Schimbi data de început?',
              updateExpiresAtTitle: 'Schimbi data de expirare?',
              cancel: 'Anulează',
              confirm: 'Confirmă',
              notSpecified: 'Nespecificat'
            }
          },
          newsBanners: {
            title: 'Bannere de știri',
            listSubtitle: 'Bannere HTML pentru clienți și prestatori în aplicație',
            create: 'Creează banner',
            cancelCreate: 'Ascunde formularul',
            refresh: 'Reîmprospătează lista',
            submit: 'Creează banner',
            submitting: 'Se salvează...',
            saveChanges: 'Salvează modificările',
            deleting: 'Se șterge...',
            createSuccess: 'Bannerul a fost creat cu succes.',
            createError: 'Nu s-a putut crea bannerul',
            updateError: 'Nu s-a putut actualiza bannerul',
            deleteError: 'Nu s-a putut șterge bannerul',
            loadError: 'Nu s-au putut încărca bannerele',
            empty: 'Încă nu există bannere',
            noText: 'Fără text',
            htmlContent: 'Conținut HTML',
            htmlPlaceholder: '<div style="padding:16px">Textul bannerului</div>',
            preview: 'Previzualizare',
            previewEmpty: 'Aici va apărea previzualizarea bannerului',
            zoom: {
              open: 'Deschide vizualizarea mărită',
              in: 'Mărește',
              out: 'Micșorează',
              reset: 'Resetează zoom-ul',
              close: 'Închide'
            },
            startsAt: 'Afișare de la',
            expiresAt: 'Afișare până la',
            registeredFrom: 'Înregistrare de la',
            registeredTo: 'Înregistrare până la',
            registeredHint: 'Bannerul va fi văzut doar de utilizatorii noi înregistrați în această perioadă.',
            edit: 'Editează',
            delete: 'Șterge',
            editTitle: 'Editează bannerul',
            editNote: 'Conținutul HTML nu poate fi modificat — actualizează perioada și audiența.',
            statusLive: 'Activ',
            statusIdle: 'Neafișat',
            totalCount: 'Total bannere: {{count}}',
            audienceLabel: 'Audiență',
            audience: {
              all: 'Toate rolurile',
              customer: 'Clienți',
              provider: 'Prestatori',
              users: 'După lista de ID',
              usersCount: '{{count}} util.'
            },
            userIdsPlaceholder: 'UUID separate prin virgulă sau rând nou',
            userIdsHint: 'Când este furnizată o listă, doar acești utilizatori văd bannerul (rolul este ignorat).',
            errorHtml: 'Introduceți conținutul HTML al bannerului',
            errorDateOrder: 'Data de sfârșit trebuie să fie ulterioară datei de început',
            errorRegisteredDateOrder: 'Data „până la” trebuie să fie ulterioară datei „de la”',
            errorUsersRequired: 'Introduceți cel puțin un ID de utilizator',
            errorUsersInvalid: 'Format ID invalid: {{ids}}',
            confirm: {
              deleteTitle: 'Ștergeți bannerul?',
              deleteSubtitle: 'Acțiunea este ireversibilă. Bannerul nu va mai fi afișat utilizatorilor.',
              cancel: 'Anulează',
              delete: 'Șterge',
              notSpecified: 'Nespecificat'
            }
          },
          publicFiles: {
            title: 'Fișiere publice',
            listSubtitle: 'Fișiere publice pentru iconițele serviciilor din marketplace și alte nevoi',
            upload: 'Încarcă fișier',
            cancelUpload: 'Ascunde formularul',
            refresh: 'Reîmprospătează lista',
            submit: 'Încarcă',
            submitting: 'Se încarcă...',
            uploadSuccess: 'Fișierul a fost încărcat cu succes.',
            uploadError: 'Nu s-a putut încărca fișierul',
            loadError: 'Nu s-au putut încărca fișierele',
            empty: 'Încă nu există fișiere',
            file: 'Fișier',
            fileHint: 'O imagine accesibilă public (de exemplu, iconița unui serviciu din marketplace).',
            preview: 'Previzualizare',
            url: 'Link',
            totalCount: 'Total fișiere: {{count}}',
            errorFileRequired: 'Selectați un fișier pentru încărcare',
            delete: 'Șterge',
            deleting: 'Se șterge...',
            deleteError: 'Nu s-a putut șterge fișierul',
            confirm: {
              deleteTitle: 'Ștergeți fișierul?',
              deleteSubtitle: 'Fișierul va fi eliminat definitiv din stocare. Dacă este folosit undeva (de exemplu, ca iconiță de serviciu), linkul va înceta să funcționeze.',
              cancel: 'Anulează',
              delete: 'Șterge'
            }
          },
          deleteUser: {
            title: 'Ștergerea utilizatorului',
            subtitle: 'Găsiți utilizatorul și ștergeți-i contul definitiv',
            warning: 'Ștergerea este definitivă: profilul și toate datele asociate vor fi șterse pentru totdeauna. Verificați că ați ales utilizatorul corect.',
            searchPlaceholder: 'Nume, telefon sau ID utilizator',
            clear: 'Golește',
            hintName: 'Nume',
            hintPhone: 'Telefon',
            hintId: 'UUID profil',
            emptyTitle: 'Începeți căutarea',
            emptyText: 'Introduceți numele, numărul de telefon sau ID-ul pentru a găsi utilizatorul.',
            noResults: 'Nu s-a găsit nimeni',
            noResultsText: 'Verificați interogarea — încercați numărul complet de telefon sau UUID-ul.',
            noName: 'Fără nume',
            found: 'Afișate {{shown}} din {{total}}',
            refineHint: 'Nu sunt afișate toate rezultatele — precizați interogarea.',
            searchError: 'Căutarea a eșuat',
            delete: 'Șterge',
            deleting: 'Se șterge...',
            deleteError: 'Nu s-a putut șterge utilizatorul',
            deleteSuccess: 'Utilizatorul „{{name}}” a fost șters',
            confirm: {
              title: 'Ștergeți utilizatorul definitiv?',
              subtitle: 'Această acțiune nu poate fi anulată. Asigurați-vă că ștergeți contul corect.',
              consequenceProfile: 'Profilul și accesul la cont vor fi eliminate',
              consequenceData: 'Datele asociate utilizatorului vor fi șterse',
              consequenceIrreversible: 'Contul nu va putea fi restabilit',
              acknowledge: 'Înțeleg că ștergerea este ireversibilă',
              cancel: 'Anulează',
              delete: 'Șterge definitiv'
            }
          },
          marketplace: {
            title: 'Marketplace',
            subtitle: 'Servicii de marketplace pentru clienți și statistica achizițiilor',
            priceValue: '{{price}} MDL',
            tabs: {
              services: 'Servicii',
              purchases: 'Achiziții'
            },
            purchaseStatuses: {
              OPEN: 'Deschisă',
              IN_PROGRESS: 'În lucru',
              CLOSED: 'Închisă'
            },
            services: {
              icon: 'Pictogramă',
              iconPlaceholder: '🧰 sau https://...',
              iconHint: 'Emoji, text sau un link către imagine',
              serviceTitle: 'Titlu',
              serviceTitleLang: 'Titlu ({{lang}})',
              titlePlaceholder: 'Titlul serviciului',
              description: 'Descriere',
              descriptionLang: 'Descriere ({{lang}})',
              descriptionPlaceholder: 'Scurtă descriere a serviciului',
              languages: {
                ro: 'Română',
                ru: 'Rusă',
                en: 'Engleză'
              },
              langHint: 'Titlul este obligatoriu în toate cele trei limbi, descrierea este opțională',
              price: 'Preț',
              pricePlaceholder: '100',
              createdAt: 'Creat',
              create: 'Creează serviciu',
              cancelCreate: 'Ascunde formularul',
              refresh: 'Reîmprospătează lista',
              submit: 'Creează',
              submitting: 'Se salvează...',
              saveChanges: 'Salvează modificările',
              deleting: 'Se șterge...',
              edit: 'Editează',
              delete: 'Șterge',
              editTitle: 'Editează serviciul',
              createSuccess: 'Serviciul a fost creat cu succes.',
              createError: 'Nu s-a putut crea serviciul',
              updateError: 'Nu s-a putut actualiza serviciul',
              deleteError: 'Nu s-a putut șterge serviciul',
              loadError: 'Nu s-au putut încărca serviciile',
              empty: 'Încă nu există servicii',
              noDescription: 'Fără descriere',
              totalCount: 'Total servicii: {{count}}',
              errorIcon: 'Indicați pictograma serviciului',
              errorTitle: 'Indicați titlul serviciului',
              errorTitleLang: 'Indicați titlul serviciului în limba: {{lang}}',
              errorPrice: 'Introduceți un preț valid (număr întreg mai mare ca 0)'
            },
            purchases: {
              refresh: 'Reîmprospătează',
              loadError: 'Nu s-au putut încărca achizițiile',
              empty: 'Încă nu există achiziții',
              totalLabel: 'Total achiziții',
              totalCount: 'Total achiziții: {{count}}',
              sort: 'Sortare',
              sortByDate: 'După dată',
              sortByPrice: 'După preț',
              sortByStatus: 'După status',
              user: 'Utilizator',
              service: 'Serviciu',
              price: 'Preț',
              status: 'Status',
              createdAt: 'Data achiziției',
              changeStatus: 'Schimbă statusul',
              newStatus: 'Status nou',
              saveStatus: 'Salvează statusul',
              statusError: 'Nu s-a putut schimba statusul achiziției'
            },
            confirm: {
              cancel: 'Anulează',
              delete: 'Șterge',
              deleteTitle: 'Ștergeți serviciul?',
              deleteSubtitle: 'Acțiunea este ireversibilă. Serviciul va dispărea din marketplace.'
            }
          },
          transactions: {
            title: 'Tranzacții',
            refresh: 'Actualizează',
            totalCount: 'Total tranzacții: {{count}}',
            loadError: 'Nu s-au putut încărca tranzacțiile',
            empty: 'Încă nu există tranzacții',
            amountValue: '{{amount}} MDL',
            filters: {
              userProfileId: 'ID utilizator',
              userProfileIdPlaceholder: 'UUID utilizator',
              orderId: 'ID comandă',
              orderIdPlaceholder: 'UUID comandă',
              type: 'Tip operațiune',
              allTypes: 'Toate tipurile',
              typesSelected: 'Tipuri selectate: {{count}}',
              createdFrom: 'Data de la',
              createdTo: 'Data până la'
            },
            summary: {
              totalCredit: 'Alimentări',
              totalDebit: 'Retrageri',
              net: 'Total',
              byType: 'După tipul operațiunii'
            },
            table: {
              type: 'Tip',
              amount: 'Sumă',
              balanceAfter: 'Sold după',
              userProfileId: 'Utilizator',
              orderId: 'Comandă',
              createdAt: 'Data',
              openUser: 'Deschide profilul utilizatorului',
              openOrder: 'Deschide comanda'
            },
            types: {
              TOPUP_MODERATOR: 'Alimentare de moderator',
              TOPUP_PACKAGE_PURCHASE: 'Achiziție pachet',
              TOPUP_PACKAGE_PURCHASE_MIA: 'Achiziție pachet (MIA)',
              FIRST_PACKAGE_BONUS: 'Bonus primul pachet',
              REFERRAL_BONUS: 'Bonus de recomandare',
              WITHDRAWAL_MODERATOR: 'Retragere de moderator',
              ORDER_PARTICIPATION: 'Participare la comandă',
              ORDER_PAYMENT: 'Plată comandă'
            }
          },
          notifications: {
            badge: 'Notificări',
            title: 'Trimite Notificări Push',
            subtitle: 'Trimite notificări push: tuturor utilizatorilor, după filtre sau ID.',
            heroTitle: 'Notificări Push',
            heroSubtitle: 'Mesaj aplicație: text, audiență și ecran.',
            formLabel: 'Notificare Push',
            formTitle: 'Compune și Trimite',
            sectionContent: 'Mesaj și Audiență',
            sectionTechnical: 'Parametri Tehnici',
            titleField: 'Titlu',
            titlePlaceholder: 'Titlul notificării',
            description: 'Descriere',
            descriptionPlaceholder: 'Textul mesajului',
            imageUrl: 'URL imagine (opțional)',
            language: 'Limbă',
            targetType: 'Către cine',
            targetAll: 'Toți utilizatorii',
            targetUsers: 'Utilizatori specifici (după ID)',
            targetFilters: 'După filtre (roluri / platformă)',
            byFilters: 'După filtre',
            byId: 'După ID',
            profileIds: 'ID-uri profil (prin virgulă)',
            targetRole: 'Rol Destinatar',
            recipient: {
              customer: 'Client',
              provider: 'Meșter'
            },
            screen: 'Ecran la deschidere',
            mediaAndLocale: 'Media și Localizare',
            languageRu: 'Rusă',
            languageRo: 'Română',
            languageEn: 'Engleză',
            platform: 'Platformă',
            send: 'Trimite',
            sending: 'Se trimite...',
            sent: 'Notificare trimisă cu succes!',
            sendError: 'Eroare la trimitere',
            sendResultStats: 'Total: {{total}} · livrate: {{success}} · eșuate: {{failure}}',
            mediaSection: 'Media',
            localeTabsLabel: 'Limba textului notificării',
            languages: {
              ru: 'Rusă',
              ro: 'Română',
              en: 'Engleză'
            },
            failedTitle: 'Nelivrate ({{count}}):',
            copyIds: 'Copiază',
            copied: 'Copiat',
            screens: {
              clientPending: 'Servicii în așteptare',
              clientActive: 'Servicii în lucru',
              clientCompleted: 'Servicii finalizate',
              clientNewRequest: 'Cerere nouă',
              clientNotifications: 'Notificări',
              clientProfile: 'Profil',
              clientSettings: 'Setări',
              masterPurchased: 'Servicii cumpărate',
              masterActive: 'Servicii în lucru',
              masterCompleted: 'Servicii finalizate',
              masterMarketplace: 'Marketplace',
              masterWallet: 'Portofel',
              masterCards: 'Cardurile mele',
              masterProfile: 'Profilul meu',
              masterPortfolio: 'Portofoliu',
              masterReviews: 'Recenzii'
            },
            profileIdsPlaceholder: 'UUID, UUID...',
            imageUrlPlaceholder: 'https://...',
            saveToHistory: 'Salvează notificarea în istoric',
            saveToUserLabel: 'Salvează la utilizator',
            saveToDbLabel: 'Salvează în BD',
            confirm: {
              title: 'Confirmă trimiterea',
              subtitle: 'Verificați mesajul, filtrele și destinatarii înainte de trimitere.',
              send: 'Trimite',
              sectionMessage: 'Textul notificării',
              sectionParams: 'Setări de livrare',
              badgeFilters: 'După filtre',
              badgeById: 'După ID',
              idsShowAll: 'Arată tot',
              idsShowLess: 'Restrânge'
            },
            validation: {
              titleRequired: 'Completați titlul',
              descriptionRequired: 'Completați textul mesajului',
              profileIdsRequired: 'Introduceți cel puțin un ID de profil',
              platformRequired: 'Selectați cel puțin o platformă (Android sau iOS)'
            },
            schedule: {
              sectionTitle: 'Programare',
              toggleNow: 'Trimite acum',
              toggleLater: 'Programează',
              submit: 'Programează',
              date: 'Data',
              time: 'Ora',
              add: 'Adaugă',
              removeSlot: 'Elimină ora',
              pickDateTime: 'Alegeți data și ora',
              pastError: 'Nu se poate programa în trecut',
              duplicate: 'Această oră este deja adăugată',
              noSlots: 'Adăugați cel puțin o oră de trimitere',
              tzHint: 'Ora este în fusul Chișinău (Europe/Chisinau)',
              scheduledOk: 'Notificare programată ({{count}})'
            },
            scheduledList: {
              title: 'Notificări programate',
              refresh: 'Reîmprospătează',
              loading: 'Se încarcă...',
              empty: 'Nu există notificări programate',
              request: 'Date cerere',
              cancel: 'Anulează',
              cancelling: 'Se anulează...',
              cancelConfirm: 'Anulați această notificare programată?',
              cancelled: 'Notificare anulată',
              loadError: 'Nu s-a putut încărca lista',
              cancelError: 'Nu s-a putut anula notificarea'
            }
          }
        },
        login: {
          title: 'Autentificare',
          phone: 'Număr de telefon',
          password: 'Parolă',
          role: 'Rol',
          selectRole: 'Selectează rolul',
          submit: 'Conectare',
          phonePlaceholder: '12345678',
          remember: 'Ține-mă minte',
          showPassword: 'Arată parola',
          hidePassword: 'Ascunde parola'
        },
        home: {
          title: 'Acasă',
          subtitle: 'Bine ați venit în panoul de suport!',
          logs: {
            title: 'Loguri de sistem',
            subtitle: 'Total înregistrări: {{count}}',
            loading: 'Se încarcă logurile...',
            emptyTitle: 'Nu s-au găsit loguri',
            emptyText: 'Sistemul nu a înregistrat acțiuni corespunzătoare.',
            expand: 'Extinde',
            collapse: 'Restrânge',
            reason: 'Motiv',
            actor: 'Actor',
            target: 'Țintă',
            payload: 'Date',
            filters: {
              actionContainsPlaceholder: 'Căutare după acțiune...',
              targetId: 'ID obiect',
              actorId: 'ID executant',
              targetIdPlaceholder: 'Introdu ID obiect...',
              actorIdPlaceholder: 'Introdu ID executant...',
              from: 'Data de la',
              to: 'Data până la',
              sortByCreatedDate: 'Data creării'
            }
          },
          tabs: {
            system: 'Loguri de sistem',
            orders: 'Loguri comenzi',
            transactions: 'Tranzacții'
          },
          orderLogs: {
            title: 'Loguri de moderare a comenzilor',
            subtitle: 'Total înregistrări: {{count}}',
            loading: 'Se încarcă logurile comenzilor...',
            emptyTitle: 'Nu s-au găsit loguri de comenzi',
            emptyText: 'Încă nu există înregistrări de moderare a comenzilor.',
            untitled: 'Fără titlu',
            statusOk: 'OK',
            statusError: 'Eroare',
            attempts: 'Încercări: {{count}}',
            description: 'Descriere',
            aiError: 'Eroare AI',
            user: 'Utilizator',
            createdAt: 'Creat',
            updatedAt: 'Actualizat',
            exportCsv: 'Export CSV',
            exportAll: 'Exportă tot (CSV)',
            exporting: 'Se exportă...',
            csvExportEmpty: 'Nu există loguri pe pagina curentă de exportat',
            csvExportError: 'Exportul logurilor a eșuat',
            filters: {
              sortByCreatedDate: 'Data creării',
              sortByUpdatedDate: 'Data actualizării',
              sortByAttempts: 'Număr de încercări',
              userId: 'ID utilizator',
              userIdPlaceholder: 'Introdu ID utilizator...'
            }
          }
        },
        orders: {
          title: 'Comenzi',
          loading: 'Se încarcă comenzile...',
          purchased: 'cumpărat',
          filters: {
            name: 'Nume',
            namePlaceholder: 'Introdu numele comenzii',
            allStatuses: 'Toate statusurile',
            sortButton: 'Sortare',
            sortBy: 'Sortează după',
            sortByDate: 'Data actualizării',
            sortByCreatedDate: 'Data creării',
            id: 'ID comandă',
            idPlaceholder: 'Introdu ID...',
            sortDirection: 'Direcție',
            descending: 'Descrescător',
            ascending: 'Crescător',
            extraFilters: 'Filtre suplimentare',
            allLanguages: 'Toate limbile',
            languageRu: 'Rusă',
            languageEn: 'Engleză',
            languageRo: 'Română',
            neverBought: 'Necumpărată',
            allPurchaseStatuses: 'Toate comenzile',
            dateFrom: 'Data de la',
            dateTo: 'Data până la',
            statusDatesTitle: 'Data schimbării statusului',
            statusDates: {
              IN_WORK: 'În lucru',
              DONE: 'Finalizată',
              CANCELED: 'Anulată'
            }
          },
          statusLabels: {
            IN_PROGRESS: 'în așteptare',
            IN_WORK: 'În lucru',
            DONE: 'Finalizat',
            DONE_DELETED: 'Finalizat (șters de client)',
            CANCELED: 'Anulat',
            BLOCKED: 'blocat',
            UNKNOWN: 'Necunoscut'
          },
          empty: {
            title: 'Nu s-au găsit comenzi',
            subtitle: 'Încercați să modificați filtrele'
          },
          exportCsv: 'Export CSV',
          exportAll: 'Exportă tot (CSV)',
          exporting: 'Se exportă...',
          csvExportEmpty: 'Nu există comenzi pe pagina curentă de exportat'
        },
        users: {
          title: 'Utilizatori',
          loading: 'Se încarcă utilizatorii...',
          filters: {
            allRoles: 'Toate rolurile',
            allStatuses: 'Toate statusurile',
            namePlaceholder: 'Introdu un nume...',
            phone: 'Telefon',
            phonePlaceholder: 'Introdu numărul...',
            role: 'Rol',
            status: 'Status',
            verification: 'Verificare',
            allVerification: 'Orice verificare',
            verifiedOnly: 'Doar verificați',
            notVerifiedOnly: 'Doar neverificați',
            marketingConsent: 'Consimțământ marketing',
            allMarketingConsent: 'Orice consimțământ',
            marketingConsentYes: 'Abonați la newsletter',
            marketingConsentNo: 'Fără consimțământ',
            dateFrom: 'Data de la',
            dateTo: 'Data până la',
            ratingFrom: 'Rating de la',
            ratingTo: 'Rating până la',
            ratingRangeShortFrom: 'De la',
            ratingRangeShortTo: 'Până la',
            ordersCount: 'Număr de comenzi',
            ordersCountPlaceholder: 'De ex. 5',
            ordersCountOrMore: 'și mai mult',
            sortButton: 'Sortare',
            sortBy: 'Sortează după',
            id: 'ID utilizator',
            idPlaceholder: 'Introdu ID...',
            sortByFullName: 'După nume',
            sortByRating: 'După rating',
            sortByDate: 'Data actualizării',
            sortByCreatedDate: 'Data creării',
            descending: 'Descrescător',
            ascending: 'Crescător',
            sortDirection: 'Direcție',
            providerCategories: 'Categorii furnizor',
            providerCategoriesHint: 'Se poate alege o singură categorie — în listă rămân furnizorii din acea categorie.',
            categoriesSearchPlaceholder: 'Caută categorie după nume...',
            categoriesLoading: 'Se încarcă categoriile...',
            categoriesEmpty: 'Nicio categorie nu corespunde căutării',
            categoriesError: 'Nu s-au putut încărca categoriile',
            categoriesClearSelected: 'Șterge categoriile',
            categoriesRemoveChip: 'Elimină categoria',
            regions: 'Regiuni companii',
            regionsHint: 'Poți selecta mai multe regiuni — vor rămâne utilizatorii cu companii din aceste regiuni.',
            regionsSearchPlaceholder: 'Caută regiune după nume...',
            regionsLoading: 'Se încarcă regiunile...',
            regionsEmpty: 'Nicio regiune găsită',
            regionsError: 'Nu s-au putut încărca regiunile',
            regionsClearSelected: 'Șterge regiunile',
            regionsRemoveChip: 'Elimină regiunea'
          },
          roles: {
            CUSTOMER: 'Client',
            PROVIDER: 'Meșter',
            SUPPORT: 'Suport',
            MODERATOR: 'Moderator',
            ADMIN: 'Administrator',
            DEV: 'Dezvoltator',
            CLIENT: 'Client',
            EMPLOYEE: 'Angajat'
          },
          statuses: {
            ACTIVE: 'Activ',
            INACTIVE: 'Inactiv',
            BLOCKED: 'Blocat'
          },
          plans: {
            BASIC: 'Bază',
            PREMIUM: 'Premium',
            PRO: 'Pro',
            basic: 'Bază'
          },
          labels: {
            reviews: 'recenzii',
            orders: 'comenzi',
            notProvided: 'Nespecificat',
            verified: 'Verificat',
            notVerified: 'Neverificat'
          },
          empty: {
            title: 'Nu s-au găsit utilizatori',
            subtitle: 'Încercați să modificați filtrele'
          },
          exportCsv: 'Export CSV',
          exportAll: 'Exportă tot (CSV)',
          exporting: 'Se exportă...',
          csvExportEmpty: 'Nu există utilizatori pe pagina curentă de exportat',
          adminExportCsv: 'Export admin (CSV)',
          adminExportAllCsv: 'Export admin, tot (CSV)',
          adminExporting: 'Se exportă...',
          actions: {
            button: 'Acțiuni',
            generateReport: 'Generează raport',
            generateReportHint: 'Toate câmpurile, inclusiv comenzi și plăți',
            exportData: 'Export date',
            exportDataHint: 'ID, nume și telefon în CSV',
            adminBadge: 'Admin',
            back: 'Înapoi',
            audienceTitle: 'Pe cine exportăm?',
            audienceAll: 'Toți utilizatorii',
            audienceAllHint: 'Conform filtrelor curente',
            audienceMarketing: 'Doar pentru newsletter',
            audienceMarketingHint: 'Filtrele curente + consimțământ marketing',
            preparing: 'Se pregătește fișierul...',
            empty: 'Nu există utilizatori de exportat',
            failed: 'Exportul utilizatorilor a eșuat'
          }
        },
        complaints: {
          title: 'Sesizări',
          loading: 'Se încarcă sesizările...',
          filters: {
            allStatuses: 'Toate statusurile'
          },
          empty: {
            title: 'Nu s-au găsit sesizări',
            subtitle: 'Nu s-a găsit nimic pentru solicitarea dvs.'
          },
          statuses: {
            PENDING: 'În așteptare',
            IN_REVIEW: 'În revizuire',
            RESOLVED: 'Rezolvat',
            REJECTED: 'Respins'
          },
          targetTypes: {
            USER: 'Utilizator',
            COMMENT: 'Comentariu',
            ORDER: 'Comandă'
          },
          filters: {
            allTypes: 'Toate tipurile',
            searchPlaceholder: 'Caută după ID sau descriere...'
          },
          labels: {
            reporterId: 'Raportor'
          }
        },
        orderDetails: {
          title: 'Comandă',
          loading: 'Încărcare...',
          error: 'Eroare la încărcarea comenzii',
          notFound: 'Comanda nu a fost găsită',
          missing: 'Comanda cu ID {{id}} nu a fost găsită',
          status: {
            inWork: 'În lucru'
          },
          sections: {
            main: 'Informații Principale',
            customer: 'Client',
            companiesLabel: 'Companii',
            executingCompany: 'Compania executantă'
          },
          fields: {
            category: 'Categorie',
            description: 'Descriere',
            price: 'Preț',
            tags: 'Etichete:'
          },
          address: {
            title: 'Adresa Comenzii'
          },
          timeline: {
            title: 'Cronologie',
            startDate: 'Data Începerii',
            createdAt: 'Data Creării',
            updatedAt: 'Data Actualizării'
          },
          photos: {
            title: 'Fotografii Comandă'
          },
          companies: {
            empty: 'Nu s-au găsit companii'
          },
          changeStatus: 'Schimbă Statusul',
          selectStatusPlaceholder: 'Selectează statusul',
          confirmStatusChange: 'Schimbi statusul comenzii în «{{status}}»?',
          tabs: {
            main: 'Informații principale',
            interaction: 'Interacțiune'
          },
          summary: {
            title: 'Rezumat comandă'
          },
          interaction: {
            statusTitle: 'Status comandă',
            masterLabel: 'Compania asignată comenzii',
            masterPlaceholder: 'Selectați compania',
            masterRequired: 'Selectați o companie înainte de a schimba statusul',
            noteTitle: 'Note suport pentru această comandă',
            notePlaceholder: 'Adaugă o notă internă pentru echipa de suport despre această comandă...',
            clear: 'Șterge',
            save: 'Salvează',
            deleteConfirm: 'Ștergi această notă?'
          }
        },
        complaintDetails: {
          title: 'Sesizare #{{id}}',
          error: 'Eroare la încărcarea sesizării',
          notFound: 'Sesizarea nu a fost găsită',
          changeStatus: 'Schimbă Statusul',
          selectStatusPlaceholder: 'Selectează statusul',
          mainInfo: 'Informații Principale',
          description: 'Descrierea sesizării',
          reviewTitle: 'Comentariu',
          reviewError: 'Eroare la încărcarea recenziei',
          metadata: 'Metadate',
          labels: {
            type: 'TIP OBIECT',
            reporterId: 'ID RAPORTOR',
            targetId: 'ID OBIECT',
            createdAt: 'DATA CREĂRII',
            updatedAt: 'DATA ACTUALIZĂRII'
          },
          reviewButtons: {
            viewReviewer: 'Vezi Raportor',
            viewReviewed: 'Vezi Profil'
          }
        },
        userDetails: {
          title: 'Profil Utilizator',
          loading: 'Încărcare...',
          edit: 'Editează',
          editUser: 'Editează Utilizator',
          contact: 'Contacte',
          personal: 'Date Personale',
          business: 'Afaceri',
          system: 'Info Sistem',
          tabs: {
            profile: 'Profil',
            reviews: 'Recenzii ({{count}})',
            orders: 'Comenzi Cumpărate',
            clientOrders: 'Comenzi ({{count}})',
            interaction: 'Interacțiune'
          },
          statusActions: {
            change: 'Schimbă',
            changeTitle: 'Schimbă statusul',
            blockAction: 'Blochează',
            blockQuestion: 'Blochezi utilizatorul {{name}}?',
            unblockAction: 'Deblochează',
            unblockQuestion: 'Deblochezi utilizatorul {{name}}?',
            deactivateAction: 'Dezactivează',
            statusChangeQuestion: 'Schimbi statusul utilizatorului {{name}} în "{{status}}"?'
          },
          labels: {
            fullName: 'Nume complet',
            role: 'Rol',
            verified: 'Verificare',
            balance: 'Balanță',
            marketplaceBalance: 'Balanță marketplace',
            inDebt: 'În datorie',
            phone: 'Telefon',
            email: 'Email',
            address: 'Adresă',
            dateOfBirth: 'Data nașterii',
            gender: 'Gen',
            language: 'Limbă',
            company: 'Companie',
            companyRating: 'Rating Companie',
            referralCode: 'Cod Ref.',
            referrals: 'Referali',
            referralsPeriod: 'Pe perioadă',
            userId: 'User ID',
            created: 'Creat',
            updated: 'Actualizat',
            debtStartedAt: 'Datorie din',
            marketingConsent: 'Newsletter',
            marketingConsentAt: 'Data consimțământului',
            marketingAgreed: 'Abonat',
            marketingDeclined: 'Refuzat',
            marketingNoAnswer: 'Fără răspuns'
          },
          balance: {
            edit: 'Editează Balanța',
            title: 'Ajustare Balanță',
            currentBalance: 'Balanță curentă',
            actionType: 'Tip operațiune',
            add: 'Adaugă',
            subtract: 'Retrage',
            subtracting: 'Retragere',
            adding: 'Depunere',
            amount: 'Sumă',
            reason: 'Motiv',
            reasonPlaceholder: 'Specificați motivul modificării...',
            current: 'Curentă',
            resulting: 'Finală',
            confirm: 'Confirmă',
            confirmTitle: 'Confirmare',
            opType: 'Operațiune',
            success: 'Balanță ajustată cu succes',
            error: 'Eroare la ajustarea balanței',
            debtJustNow: 'chiar acum',
            errors: {
              amountInvalid: 'Suma trebuie să fie de cel puțin 1',
              amountTooLarge: 'Suma nu poate depăși {{max}} MDL',
              balanceExceedsMax: 'Balanța va depăși {{max}} MDL',
              insufficientBalance: 'Fonduri insuficiente în balanță',
              reasonRequired: 'Motivul este obligatoriu'
            }
          },
          company: {
            title: 'Portofoliu',
            loading: 'Se încarcă datele...',
            name: 'Nume',
            rating: 'Rating',
            languages: 'Limbi',
            openToUrgent: 'Comenzi urgente',
            minimumCallOutPrice: 'Preț min. deplasare',
            workInfo: 'Muncă',
            teamSize: 'Mărimea echipei',
            team: 'Lucrează cu echipă',
            schedule: 'Program',
            about: 'Despre',
            description: 'Descriere',
            bio: 'Bio',
            categories: 'Categorii',
            regions: 'Regiuni',
            services: 'Servicii',
            documents: 'Documente',
            photos: 'Foto',
            categoryFallback: 'Categoria {{index}}',
            serviceFallback: 'Serviciu {{index}}',
            documentFallback: 'Document {{index}}',
            photoFallback: 'Foto {{index}}'
          },
          modal: {
            cancel: 'Anulează',
            save: 'Salvează',
            editUserTitle: 'Editează Utilizator',
            status: 'Stare',
            plan: 'Abonament',
            selectGender: 'Selectează genul',
            selectLanguage: 'Selectează limba',
            selectPlan: 'Selectează abonamentul',
            male: 'Masculin',
            female: 'Feminin',
            fullNamePlaceholder: 'Introdu numele complet',
            emailPlaceholder: 'Introdu email',
            referralCodePlaceholder: 'Introdu codul de referal'
          },
          messages: {
            copied: 'Copiat!',
            userUpdated: 'Date utilizator actualizate',
            userUpdateError: 'Eroare la actualizarea datelor',
            statusUpdateError: 'Eroare la actualizarea stării',
            noteSaved: 'Notă salvată',
            reviewSaved: 'Recenzia a fost publicată'
          },
          reviews: {
            title: 'Recenzii',
            refresh: 'Actualizează',
            deleteConfirm: 'Ștergi această recenzie?',
            deleteSuccess: 'Recenzie ștearsă',
            deleteError: 'Eroare la ștergere',
            loadError: 'Eroare la încărcarea recenziilor',
            emptyTitle: 'Nicio recenzie încă',
            emptyText: 'Acest utilizator nu are recenzii încă',
            noRating: 'Nicio evaluare',
            noComment: 'Fără comentariu',
            viewProfile: 'Profil',
            deleting: 'Se șterge...',
            delete: 'Șterge'
          },
          orders: {
            title: 'Comenzi Cumpărate',
            clientTitle: 'Comenzile Clientului',
            sortBy: 'Sortează după',
            sortByCreated: 'Data creării',
            sortByUpdated: 'Data actualizării',
            sortDesc: 'Descrescător',
            sortAsc: 'Crescător',
            loading: 'Se încarcă comenzile...',
            loadError: 'Eroare la încărcarea comenzilor',
            view: 'Vezi',
            emptyTitle: 'Nicio comandă cumpărată',
            emptyText: 'Acest furnizor nu are încă comenzi cumpărate',
            clientEmptyTitle: 'Nicio comandă încă',
            clientEmptyText: 'Acest utilizator nu are încă comenzi',
            table: {
              id: 'ID Comandă',
              title: 'Titlu',
              status: 'Stare',
              accepted: 'Acceptat',
              createdAt: 'Creat',
              updatedAt: 'Actualizat',
              actions: 'Acțiuni'
            }
          },
          schedule: {
            monday: 'Luni',
            tuesday: 'Marți',
            wednesday: 'Miercuri',
            thursday: 'Joi',
            friday: 'Vineri',
            saturday: 'Sâmbătă',
            sunday: 'Duminică',
            dayOff: 'Zi liberă',
            flexible: 'Program flexibil',
            notConfigured: 'Program nconfigurat'
          },
          verification: {
            title: 'Verificare companie',
            verified: 'Companie verificată',
            notVerified: 'Companie neverificată',
            verifyAction: 'Verifică compania',
            unverifyAction: 'Elimină verificarea',
            successVerified: 'Compania a fost verificată',
            successUnverified: 'Verificarea companiei a fost eliminată',
            error: 'Eroare la actualizarea verificării: {{error}}'
          },
          interaction: {
            statusTitle: 'Stare Utilizator',
            statusSub: 'Gestionează accesul utilizatorului la platformă',
            noteTitle: 'Note Suport',
            noteSub: 'Notele interne sunt vizibile doar echipei',
            notePlaceholder: 'Adaugă o notă despre interacțiune...',
            clear: 'Șterge',
            save: 'Salvează',
            deleteConfirm: 'Ștergi această notă?',
            review: {
              title: 'Lasă o recenzie meșterului',
              subtitle: 'Publică o recenzie oficială din partea contului selectat',
              ratingLabel: 'Rating',
              reviewerLabel: 'ID-ul contului de la care se lasă recenzia',
              commentLabel: 'Comentariu',
              commentPlaceholder: 'Descrie calitatea lucrării meșterului...',
              submit: 'Publică recenzia',
              invalidReviewer: 'Introdu un ID de cont valid (UUID)'
            }
          }
        }
      }
    }
  },
  lng: initialLanguage,
  fallbackLng: 'ru',
  interpolation: {
    escapeValue: false
  }
});

i18n.on('languageChanged', (lang) => {
  const normalized = normalizeLanguage(lang);
  if (normalized) {
    localStorage.setItem('lng', normalized);
  }
});

export default i18n;
